// import React, { useState, useEffect } from 'react';
// import { useNavigate, Link } from 'react-router-dom';
// import db from './Firebase';
// import { collection, getDocs } from 'firebase/firestore/lite';

// /* ─── Inline styles ─────────────────────────────────────────────────────── */
// const G = {
//   /* palette — light theme */
//   bgDark:       '#f0f2f7',       // page background
//   sidebarBg:    '#ffffff',       // sidebar white
//   sidebarBorder:'#e4e7f0',
//   surface:      '#ffffff',       // card white
//   surface2:     '#f5f7fb',       // table header / inner bg
//   accent:       '#6c63ff',
//   accentGlow:   'rgba(108,99,255,0.10)',
//   accent2:      '#00b894',
//   textPrimary:  '#1a1d2e',
//   textSecondary:'#6b7280',
//   textMuted:    '#9ca3af',
//   success:      '#16a34a',
//   warning:      '#d97706',
//   danger:       '#dc2626',
//   info:         '#0284c7',
//   border:       '#e4e7f0',
// };

// const globalCss = `
//   @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=Space+Grotesk:wght@400;500;600;700&display=swap');

//   *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
//   html, body { height: 100%; background: ${G.bgDark}; color: ${G.textPrimary};
//     font-family: 'DM Sans', sans-serif; overflow: hidden; }

//   /* scrollbars */
//   ::-webkit-scrollbar { width: 4px; }
//   ::-webkit-scrollbar-track { background: transparent; }
//   ::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 2px; }

//   /* nav item hover */
//   .nav-item-link { transition: all .15s; }
//   .nav-item-link:hover { color: ${G.accent} !important; background: ${G.accentGlow} !important; }
//   .nav-item-link:hover .nav-dot { background: ${G.accent} !important; }
//   .nav-item-link.active-link { color: ${G.accent} !important; background: ${G.accentGlow} !important; }
//   .nav-item-link.active-link .nav-dot { background: ${G.accent} !important; }

//   /* section header hover */
//   .sec-header:hover .sec-label { color: ${G.textPrimary} !important; }

//   /* stat card hover */
//   .stat-card { transition: transform .2s, box-shadow .2s; }
//   .stat-card:hover { transform: translateY(-2px); box-shadow: 0 10px 32px rgba(108,99,255,.12); }

//   /* quick link hover */
//   .ql-pill { transition: all .15s; }
//   .ql-pill:hover { border-color: ${G.accent} !important; color: ${G.accent} !important;
//     background: ${G.accentGlow} !important; }
//   .ql-pill:hover .ql-dot-inner { background: ${G.accent} !important; }

//   /* table row */
//   .tbl-row { transition: background .15s; cursor: pointer; }
//   .tbl-row:hover { background: ${G.surface2}; }

//   /* logout */
//   .logout-btn { transition: all .2s; }
//   .logout-btn:hover { background: rgba(220,38,38,.12) !important; border-color: rgba(220,38,38,.4) !important; }

//   /* collapse animation */
//   .collapse-items {
//     overflow: hidden;
//     max-height: 0;
//     transition: max-height .38s cubic-bezier(.4,0,.2,1);
//   }
//   .collapse-items.open { max-height: 2400px; }

//   /* fade-up */
//   @keyframes fadeUp { from{opacity:0;transform:translateY(14px)} to{opacity:1;transform:translateY(0)} }
//   .fade-up { animation: fadeUp .35s ease both; }
//   .fade-up-1{animation-delay:.05s} .fade-up-2{animation-delay:.1s}
//   .fade-up-3{animation-delay:.15s} .fade-up-4{animation-delay:.2s}

//   /* section arrow */
//   .sec-arrow { transition: transform .25s, background .2s; }
//   .sec-arrow.open { transform: rotate(90deg) !important; background: ${G.accentGlow} !important; color: ${G.accent} !important; }
// `;

// /* ─── Nav data ───────────────────────────────────────────────────────────── */
// const NAV_SECTIONS = [
//   {
//     id: 'appdata', label: 'View App Data', emoji: '📊',
//     items: [
//       { label: 'Users Profile',        to: '/users_profile' },
//       { label: 'Portfolio',            to: '/portfolio_data' },
//       { label: 'Portfolio Analyser',   to: '/portfolio_analyser' },
//       { label: 'Portfolio Reviews',    to: '/portfolio_reviews' },
//       { label: 'Customer Data',        to: '/customer_data' },
//       { label: 'Referred Courses',     to: '/referred_courses' },
//       { label: "User's Location",      to: '/location_data' },
//       { label: 'Website Message',      to: '/website_message' },
//       { label: 'App Feedback',         to: '/app_feedback' },
//       { label: 'Appointment Analyser', to: '/appointment_analyser' },
//       { label: 'My Business',          to: '/my_business' },
//       { label: 'Clicked Logs',         to: '/clicked_logs' },
//       { label: 'All Certificates',     to: '/all_certificates' },
//       { label: 'Workshop Feedback',    to: '/workshop_feedback' },
//       { label: 'Workshops Payment',    to: '/workshop_payment' },
//       { label: 'Expense List',         to: '/expenses_list' },
//       { label: 'Registration Count',   to: '/workshop_registration_count' },
//       { label: 'App Referral',         to: '/app_referral' },
//       { label: 'Feedback Reply',       to: '/feedback_reply' },
//       { label: 'Users Checkin',        to: '/user_last_checkin' },
//       { label: 'Login Logs',           to: '/login_logs' },
//       { label: 'Downloaded Cert.',     to: '/downloaded_certificate' },
//       { label: 'Topic Request',        to: '/topic_request' },
//     ],
//   },
//   {
//     id: 'requests', label: 'View All Requests', emoji: '📨',
//     items: [
//       { label: 'Beauty Kit Requests',      to: '/beauty_kit_requests' },
//       { label: 'Upcoming Session',         to: '/upcoming_session' },
//       { label: 'Book Demo Requests',       to: '/book_demo_requests' },
//       { label: 'Hire Requests',            to: '/hire_request' },
//       { label: 'Event Requests',           to: '/event_request' },
//       { label: 'Loan Requests',            to: '/loan_request' },
//       { label: 'Loan Remarks',             to: '/loan_remark' },
//       { label: 'Workshop Registration',    to: '/workshop_registration' },
//       { label: 'Workshop Payment',         to: '/workshop_payment' },
//       { label: 'All Workshop',             to: '/workshop' },
//       { label: 'Workshop Query',           to: '/workshop_query' },
//       { label: 'Workshop Event Request',   to: '/workshop_event_request' },
//       { label: 'Delete Portfolio Req.',    to: '/delete_portfolio_req' },
//       { label: 'Advertise Feedback',       to: '/advertise_feedback' },
//     ],
//   },
//   {
//     id: 'create', label: 'Create', emoji: '✏️',
//     items: [
//       { label: 'Guidance Session',         to: '/guidance_session' },
//       { label: 'Workshop',                 to: '/workshop_data' },
//       { label: 'Workshop Hindi',           to: '/workshop_data_hindi' },
//       { label: 'Workshop Reminder',        to: '/workshop_reminder' },
//       { label: 'Pin Workshop',             to: '/pin_workshop' },
//       { label: 'Workshop Attendance',      to: '/workshop_attendance' },
//       { label: 'Workshop Glimpses',        to: '/workshop_glimpses' },
//       { label: 'Attendance Status',        to: '/workshop_attendance_status' },
//       { label: 'Upload Recorded Session',  to: '/upload_recorded_video' },
//       { label: 'Upload Certificate',       to: '/upload_certificates' },
//       { label: 'Send Whatsapp',            to: '/send_whatsapp' },
//       { label: 'Create Whatsapp Template', to: '/create_whatsapp_template' },
//       { label: 'Courses',                  to: '/course_data' },
//       { label: 'Course Hindi',             to: '/course_data_hindi' },
//       { label: 'Add Slider Images',        to: '/add_slider_images' },
//       { label: 'Add Workshop Slider',      to: '/workshop_slider_image' },
//       { label: 'Add Global Notification',  to: '/global_notification' },
//       { label: 'Advertise Download',       to: '/advertise_download' },
//       { label: 'After Session Slider',     to: '/session_slider_images' },
//       { label: 'Workshop Code',            to: '/workshop_code' },
//       { label: 'Workshop Tag',             to: '/workshop_tag' },
//       { label: 'Add Adv Slider',           to: '/advertise_slider' },
//     ],
//   },
//   {
//     id: 'new', label: 'New', emoji: '🆕',
//     items: [
//       { label: 'Upload Course',            to: '/CourseUploadForm' },
//       { label: 'Add Quiz',                 to: '/add_quiz' },
//       { label: 'Add Expert',               to: '/add_expert' },
//       { label: 'Add Enrollment',           to: '/custom_enrollment' },
//       { label: 'View Course Enrollment',   to: '/course_enrollment' },
//       { label: 'Membership Data',          to: '/membership_tracking' },
//       { label: 'Booking',                  to: '/bookings' },
//       { label: 'Add Doubt Sessions',       to: '/add_doubt_session' },
//       { label: 'Doubt Sessions Data',      to: '/doubt_session' },
//       { label: 'Community',                to: '/community' },
//       { label: 'App Queries',              to: '/query_data' },
//       { label: 'Faqs Query',               to: '/faqs_query' },
//       { label: 'Profile Type',             to: '/profile_type' },
//       { label: 'Course Video Update',      to: '/course_video_update' },
//       { label: 'Course Attendance Update', to: '/course_attendance_update' },
//       { label: 'Course Timestamp Update',  to: '/course_timestamp_update' },
//       { label: 'Booked Appointments',      to: '/appointment_booked' },
//       { label: 'Appointment Analyser',     to: '/appointment_analyser' },
//       { label: 'Finance Query',            to: '/finance_query' },
//       { label: 'Certificate Download',     to: '/certificate_downloads' },
//       { label: 'Course Report',            to: '/users_course_data' },
//       { label: 'Analytics Preview',        to: '/analytics_preview' },
//       { label: 'Log Analytics',            to: '/dashbaordall' },
//       { label: 'Homepage Banner',          to: '/apptopbanner' },
//       { label: 'Homepage Poster',          to: '/homepage_poster' },
//       { label: 'Transaction History',      to: '/transaction_history' },
//       { label: 'Requested Topics',         to: '/requested_topics' },
//       { label: 'Know More About Course',   to: '/know_more_about_course' },
//       { label: 'Active Members',           to: '/active_membership' },
//       { label: 'Certificate Data',         to: '/downloaded_certificate_data' },
//       { label: 'Workshop Registration',    to: '/workshop_registrations' },
//       { label: 'Udyam Registration',       to: '/UdyamRegistrationData' },
//       { label: 'Ecommerce Support Data',   to: '/EcommerceSupportData' },
//       { label: 'Edit Course',              to: '/editcoursepage' },
//       { label: 'Hindi Workshop Name',      to: '/workshophindiversion' },
//     ],
//   },
//   {
//     id: 'grow', label: 'Grow', emoji: '🌱',
//     items: [
//       { label: 'Call Back Request', to: '/call_back_request' },
//       { label: 'Grow Data',         to: '/grow_all_data' },
//       { label: 'Ready Made Delete', to: '/readymadepage' },
//       { label: 'DIY Delete',        to: '/diycardpage' },
//       { label: 'Studio Requests',   to: '/orders_data' },
//     ],
//   },
// ];

// const RECENT_REQUESTS = [
//   { user: 'Priya Sharma',   type: 'Book Demo',             date: 'Today, 10:24 AM',      status: 'Pending',   statusClass: 'yellow' },
//   { user: 'Rohan Mehta',    type: 'Workshop Registration', date: 'Today, 9:12 AM',       status: 'Confirmed', statusClass: 'green'  },
//   { user: 'Anita Joshi',    type: 'Hire Request',          date: 'Yesterday, 5:40 PM',   status: 'In Review', statusClass: 'blue'   },
//   { user: 'Vikram Das',     type: 'Loan Request',          date: 'Yesterday, 2:10 PM',   status: 'Rejected',  statusClass: 'red'    },
//   { user: 'Sunita Kapoor',  type: 'Beauty Kit',            date: 'May 3, 11:00 AM',      status: 'Fulfilled', statusClass: 'green'  },
// ];

// const BADGE_COLORS = {
//   green:  { bg: 'rgba(34,197,94,.12)',  color: '#22c55e' },
//   yellow: { bg: 'rgba(245,158,11,.12)', color: '#f59e0b' },
//   blue:   { bg: 'rgba(56,189,248,.1)',  color: '#38bdf8' },
//   red:    { bg: 'rgba(239,68,68,.1)',   color: '#ef4444' },
// };

// /* ─── Sub-components ─────────────────────────────────────────────────────── */

// function NavSection({ section, activeLink, setActiveLink }) {
//   const [open, setOpen] = useState(false);

//   return (
//     <div>
//       {/* Section header */}
//       <div
//         className="sec-header"
//         onClick={() => setOpen(o => !o)}
//         style={{
//           display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//           padding: '16px 20px 8px', cursor: 'pointer', userSelect: 'none',
//         }}
//       >
//         <span
//           className="sec-label"
//           style={{
//             fontSize: 10.5, fontWeight: 700, letterSpacing: '.12em',
//             textTransform: 'uppercase', color: G.textMuted, transition: 'color .2s',
//           }}
//         >
//           {section.emoji}&nbsp; {section.label}
//         </span>
//         <span
//           className={`sec-arrow${open ? ' open' : ''}`}
//           style={{
//             width: 18, height: 18,
//             background: G.surface2,
//             borderRadius: 5,
//             display: 'flex', alignItems: 'center', justifyContent: 'center',
//             fontSize: 12, color: G.textMuted,
//           }}
//         >
//           ›
//         </span>
//       </div>

//       {/* Collapsible items */}
//       <div className={`collapse-items${open ? ' open' : ''}`}>
//         {section.items.map(item => (
//           <Link
//             key={item.to}
//             to={item.to}
//             className={`nav-item-link${activeLink === item.to ? ' active-link' : ''}`}
//             onClick={() => setActiveLink(item.to)}
//             style={{
//               display: 'flex', alignItems: 'center', gap: 10,
//               padding: '7px 20px 7px 30px',
//               color: G.textSecondary,
//               fontSize: 13, fontWeight: 400,
//               textDecoration: 'none',
//               position: 'relative',
//             }}
//           >
//             <span
//               className="nav-dot"
//               style={{
//                 width: 5, height: 5, borderRadius: '50%',
//                 background: G.textMuted, flexShrink: 0, transition: 'background .2s',
//               }}
//             />
//             {item.label}
//           </Link>
//         ))}
//       </div>
//     </div>
//   );
// }

// function StatCard({ icon, value, label, change, changeUp, colorClass, delay }) {
//   const topColors = {
//     purple: 'linear-gradient(90deg,#6c63ff,#a78bfa)',
//     teal:   'linear-gradient(90deg,#00d4aa,#34d399)',
//     amber:  'linear-gradient(90deg,#f59e0b,#fbbf24)',
//     sky:    'linear-gradient(90deg,#38bdf8,#7dd3fc)',
//   };
//   const iconBgs = {
//     purple: 'rgba(108,99,255,.1)',
//     teal:   'rgba(0,184,148,.12)',
//     amber:  'rgba(217,119,6,.1)',
//     sky:    'rgba(2,132,199,.1)',
//   };

//   return (
//     <div
//       className={`stat-card fade-up fade-up-${delay}`}
//       style={{
//         background: G.surface,
//         border: `1px solid ${G.border}`,
//         borderRadius: 14,
//         padding: 20,
//         position: 'relative',
//         overflow: 'hidden',
//       }}
//     >
//       {/* top accent line */}
//       <div style={{
//         position: 'absolute', top: 0, left: 0, right: 0, height: 2,
//         background: topColors[colorClass],
//       }} />
//       <div style={{
//         width: 40, height: 40, borderRadius: 10,
//         background: iconBgs[colorClass],
//         display: 'flex', alignItems: 'center', justifyContent: 'center',
//         fontSize: 18, marginBottom: 14,
//       }}>
//         {icon}
//       </div>
//       <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 28, fontWeight: 700, lineHeight: 1 }}>
//         {value}
//       </div>
//       <div style={{ fontSize: 12.5, color: G.textSecondary, marginTop: 6, fontWeight: 500 }}>
//         {label}
//       </div>
//       <div style={{
//         fontSize: 11.5, marginTop: 10, display: 'flex', alignItems: 'center', gap: 4,
//         color: changeUp ? G.success : G.danger,
//       }}>
//         {changeUp ? '↑' : '↓'} {change}
//       </div>
//     </div>
//   );
// }

// function QuickSection({ title, badge, items }) {
//   return (
//     <div style={{
//       background: G.surface, border: `1px solid ${G.border}`,
//       borderRadius: 14, padding: 20,
//     }}>
//       <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
//         <div style={{ fontSize: 14, fontWeight: 600 }}>{title}</div>
//         <div style={{
//           fontSize: 11, padding: '3px 8px', borderRadius: 6,
//           background: G.surface2, color: G.textSecondary,
//         }}>
//           {badge}
//         </div>
//       </div>
//       <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
//         {items.map(item => (
//           <div
//             key={item}
//             className="ql-pill"
//             style={{
//               padding: '6px 12px',
//               background: G.surface2,
//               border: `1px solid ${G.border}`,
//               borderRadius: 8,
//               fontSize: 12,
//               color: G.textSecondary,
//               cursor: 'pointer',
//               display: 'flex', alignItems: 'center', gap: 6,
//             }}
//           >
//             <span className="ql-dot-inner" style={{
//               width: 5, height: 5, borderRadius: '50%',
//               background: G.textMuted, flexShrink: 0,
//             }} />
//             {item}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// /* ─── Main Component ─────────────────────────────────────────────────────── */

// function AdminPanel() {
//   const navigate = useNavigate();
//   const [totalCount, setTotalCount] = useState('—');
//   const [activeLink, setActiveLink] = useState('');

//   /* inject global CSS once */
//   useEffect(() => {
//     const id = 'admin-panel-styles';
//     if (!document.getElementById(id)) {
//       const style = document.createElement('style');
//       style.id = id;
//       style.textContent = globalCss;
//       document.head.appendChild(style);
//     }
//     return () => {
//       const el = document.getElementById(id);
//       if (el) el.remove();
//     };
//   }, []);

//   /* auth guard */
//   useEffect(() => {
//     const email    = localStorage.getItem('email');
//     const password = localStorage.getItem('password');
//     const remember = localStorage.getItem('remember');
//     if (remember === 'false' || !email || !password) navigate('/signin');
//   }, [navigate]);

//   /* fetch total count */
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const snapshot = await getDocs(collection(db, 'personal_details'));
//         setTotalCount(snapshot.size.toLocaleString('en-IN'));
//       } catch (err) {
//         console.error('Error fetching data:', err);
//       }
//     };
//     fetchData();
//   }, []);

//   const logout = () => {
//     localStorage.removeItem('email');
//     localStorage.removeItem('password');
//     localStorage.removeItem('remember');
//     navigate('/signin');
//   };

//   return (
//     <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: G.bgDark }}>

//       {/* ── SIDEBAR ── */}
//       <aside style={{
//         width: 260, minWidth: 260,
//         background: G.sidebarBg,
//         borderRight: `1px solid ${G.sidebarBorder}`,
//         boxShadow: '2px 0 12px rgba(108,99,255,.06)',
//         display: 'flex', flexDirection: 'column', overflow: 'hidden',
//       }}>

//         {/* Brand */}
//         <div style={{
//           padding: '20px 20px 16px',
//           display: 'flex', alignItems: 'center', gap: 12,
//           borderBottom: `1px solid ${G.border}`, flexShrink: 0,
//         }}>
//           <div style={{
//             width: 36, height: 36,
//             background: 'linear-gradient(135deg,#6c63ff,#a78bfa)',
//             borderRadius: 10,
//             display: 'flex', alignItems: 'center', justifyContent: 'center',
//             fontSize: 16, flexShrink: 0,
//           }}>
//             ⚡
//           </div>
//           <div>
//             <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 15, fontWeight: 700 }}>
//               AdminPanel
//             </div>
//             <div style={{ fontSize: 11, color: G.textSecondary }}>Management Console</div>
//           </div>
//         </div>

//         {/* Nav scroll */}
//         <nav style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', padding: '10px 0 16px' }}>
//           {NAV_SECTIONS.map(sec => (
//             <NavSection
//               key={sec.id}
//               section={sec}
//               activeLink={activeLink}
//               setActiveLink={setActiveLink}
//             />
//           ))}

//           {/* Logout */}
//           <div style={{ padding: '12px 16px 0' }}>
//             <button
//               className="logout-btn"
//               onClick={logout}
//               style={{
//                 width: '100%', padding: '10px 16px',
//                 display: 'flex', alignItems: 'center', gap: 10,
//                 background: 'rgba(239,68,68,.08)',
//                 border: '1px solid rgba(239,68,68,.18)',
//                 borderRadius: 10,
//                 color: G.danger,
//                 fontSize: 13, fontWeight: 500,
//                 cursor: 'pointer',
//               }}
//             >
//               <span>⎋</span> Logout
//             </button>
//           </div>
//         </nav>

//         {/* Footer user row */}
//         <div style={{ padding: '14px 16px', borderTop: `1px solid ${G.border}`, flexShrink: 0 }}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//             <div style={{
//               width: 32, height: 32,
//               background: 'linear-gradient(135deg,#6c63ff,#00d4aa)',
//               borderRadius: 9,
//               display: 'flex', alignItems: 'center', justifyContent: 'center',
//               fontSize: 13, fontWeight: 700, color: '#fff', flexShrink: 0,
//             }}>A</div>
//             <div>
//               <div style={{ fontSize: 13, fontWeight: 600 }}>Admin</div>
//               <div style={{ fontSize: 11, color: G.textMuted }}>Super Admin</div>
//             </div>
//             <div style={{
//               marginLeft: 'auto',
//               width: 7, height: 7, borderRadius: '50%',
//               background: G.success,
//               boxShadow: `0 0 6px ${G.success}`,
//             }} />
//           </div>
//         </div>
//       </aside>

//       {/* ── MAIN ── */}
//       <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

//         {/* Topbar */}
//         <header style={{
//           height: 60,
//           background: G.surface,
//           borderBottom: `1px solid ${G.border}`,
//           display: 'flex', alignItems: 'center',
//           padding: '0 28px', gap: 16, flexShrink: 0,
//         }}>
//           <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 16, fontWeight: 600, flex: 1 }}>
//             Dashboard Overview
//           </div>
//           <div style={{
//             background: G.accentGlow, color: G.accent,
//             padding: '4px 12px', borderRadius: 20,
//             fontSize: 12, fontWeight: 500,
//             border: '1px solid rgba(108,99,255,.25)',
//           }}>
//             ● Live
//           </div>
//           <div style={{ fontSize: 12, color: G.textSecondary }}>
//             {new Date().toLocaleDateString('en-IN', { month: 'short', year: 'numeric' })}
//           </div>
//           <div style={{
//             width: 34, height: 34,
//             background: 'linear-gradient(135deg,#6c63ff,#00d4aa)',
//             borderRadius: 10,
//             display: 'flex', alignItems: 'center', justifyContent: 'center',
//             fontSize: 13, fontWeight: 700, color: '#fff', cursor: 'pointer',
//           }}>A</div>
//         </header>

//         {/* Scrollable content */}
//         <main style={{ flex: 1, overflowY: 'auto', padding: 28 }}>

//           {/* Page heading */}
//           <div style={{ marginBottom: 28 }}>
//             <h1 style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 24, fontWeight: 700 }}>
//               Welcome back, Admin 👋
//             </h1>
//             <p style={{ color: G.textSecondary, fontSize: 13.5, marginTop: 4 }}>
//               Here's what's happening with your platform today.
//             </p>
//           </div>

//           {/* Stat cards */}
//           <div style={{
//             display: 'grid',
//             gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
//             gap: 16, marginBottom: 28,
//           }}>
//             <StatCard icon="📱" value={totalCount}  label="App Downloads"          change="12% from last month" changeUp delay={1} colorClass="purple" />
//             <StatCard icon="🎓" value="148"          label="Workshop Registrations"  change="8% this week"       changeUp delay={2} colorClass="teal"   />
//             <StatCard icon="📋" value="34"           label="Pending Requests"        change="5 new today"        changeUp delay={3} colorClass="amber"  />
//             <StatCard icon="🏆" value="209"          label="Certificates Issued"     change="3% this month"      changeUp delay={4} colorClass="sky"    />
//           </div>

//           {/* Quick section cards */}
//           <div style={{
//             display: 'grid', gridTemplateColumns: '1fr 1fr',
//             gap: 20, marginBottom: 28,
//           }}>
//             <QuickSection title="📊 App Data"   badge={`${NAV_SECTIONS[0].items.length} sections`}
//               items={NAV_SECTIONS[0].items.slice(0,8).map(i => i.label)} />
//             <QuickSection title="📨 Requests"   badge={`${NAV_SECTIONS[1].items.length} sections`}
//               items={NAV_SECTIONS[1].items.slice(0,8).map(i => i.label)} />
//             <QuickSection title="✏️ Create"     badge={`${NAV_SECTIONS[2].items.length} sections`}
//               items={NAV_SECTIONS[2].items.slice(0,8).map(i => i.label)} />
//             <QuickSection title="🆕 New / Grow" badge={`${NAV_SECTIONS[3].items.length + NAV_SECTIONS[4].items.length} sections`}
//               items={[...NAV_SECTIONS[3].items, ...NAV_SECTIONS[4].items].slice(0,8).map(i => i.label)} />
//           </div>

//           {/* Recent requests table */}
//           <div style={{
//             background: G.surface, border: `1px solid ${G.border}`,
//             borderRadius: 14, overflow: 'hidden',
//           }}>
//             <div style={{
//               padding: '16px 20px',
//               borderBottom: `1px solid ${G.border}`,
//               display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//             }}>
//               <div style={{ fontSize: 14, fontWeight: 600 }}>Recent Requests</div>
//               <div style={{ fontSize: 12, color: G.accent, cursor: 'pointer' }}>View all →</div>
//             </div>
//             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//               <thead>
//                 <tr style={{ background: G.surface2, borderBottom: `1px solid ${G.border}` }}>
//                   {['User', 'Request Type', 'Date', 'Status'].map(h => (
//                     <th key={h} style={{
//                       padding: '10px 20px', textAlign: 'left',
//                       fontSize: 11, fontWeight: 600, letterSpacing: '.07em',
//                       textTransform: 'uppercase', color: G.textMuted,
//                     }}>{h}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {RECENT_REQUESTS.map((row, i) => {
//                   const bc = BADGE_COLORS[row.statusClass];
//                   return (
//                     <tr
//                       key={i}
//                       className="tbl-row"
//                       style={{ borderBottom: i < RECENT_REQUESTS.length - 1 ? `1px solid ${G.border}` : 'none' }}
//                     >
//                       <td style={{ padding: '12px 20px', fontSize: 13, color: G.textPrimary, fontWeight: 500 }}>{row.user}</td>
//                       <td style={{ padding: '12px 20px', fontSize: 13, color: G.textSecondary }}>{row.type}</td>
//                       <td style={{ padding: '12px 20px', fontSize: 13, color: G.textSecondary }}>{row.date}</td>
//                       <td style={{ padding: '12px 20px' }}>
//                         <span style={{
//                           display: 'inline-block', padding: '3px 9px', borderRadius: 6,
//                           fontSize: 11, fontWeight: 600,
//                           background: bc.bg, color: bc.color,
//                         }}>{row.status}</span>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>

//           {/* bottom spacer */}
//           <div style={{ height: 24 }} />
//         </main>
//       </div>
//     </div>
//   );
// }

// export default AdminPanel;



// // import React, { useState, useEffect } from 'react';
// // import { useNavigate, Link } from 'react-router-dom';
// // import db from './Firebase';
// // import { collection, getDocs } from 'firebase/firestore/lite';

// // /* ─── Inline styles ─────────────────────────────────────────────────────── */
// // const G = {
// //   /* palette */
// //   bgDark:      '#0d0f14',
// //   sidebarBg:   '#111318',
// //   sidebarBorder:'#1e2130',
// //   surface:     '#16191f',
// //   surface2:    '#1c2030',
// //   accent:      '#6c63ff',
// //   accentGlow:  'rgba(108,99,255,0.15)',
// //   accent2:     '#00d4aa',
// //   textPrimary: '#e8eaf0',
// //   textSecondary:'#7a8099',
// //   textMuted:   '#454b62',
// //   success:     '#22c55e',
// //   warning:     '#f59e0b',
// //   danger:      '#ef4444',
// //   info:        '#38bdf8',
// //   border:      '#1e2232',
// // };

// // const globalCss = `
// //   @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=Space+Grotesk:wght@400;500;600;700&display=swap');

// //   *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
// //   html, body { height: 100%; background: ${G.bgDark}; color: ${G.textPrimary};
// //     font-family: 'DM Sans', sans-serif; overflow: hidden; }

// //   /* scrollbars */
// //   ::-webkit-scrollbar { width: 4px; }
// //   ::-webkit-scrollbar-track { background: transparent; }
// //   ::-webkit-scrollbar-thumb { background: ${G.border}; border-radius: 2px; }

// //   /* nav item hover */
// //   .nav-item-link { transition: all .15s; }
// //   .nav-item-link:hover { color: ${G.textPrimary} !important; background: rgba(255,255,255,.03) !important; }
// //   .nav-item-link:hover .nav-dot { background: ${G.accent} !important; }
// //   .nav-item-link.active-link { color: ${G.accent} !important; background: ${G.accentGlow} !important; }
// //   .nav-item-link.active-link .nav-dot { background: ${G.accent} !important; }

// //   /* section header hover */
// //   .sec-header:hover .sec-label { color: ${G.textSecondary} !important; }

// //   /* stat card hover */
// //   .stat-card { transition: transform .2s, box-shadow .2s; }
// //   .stat-card:hover { transform: translateY(-2px); box-shadow: 0 10px 32px rgba(0,0,0,.35); }

// //   /* quick link hover */
// //   .ql-pill { transition: all .15s; }
// //   .ql-pill:hover { border-color: ${G.accent} !important; color: ${G.accent} !important;
// //     background: ${G.accentGlow} !important; }
// //   .ql-pill:hover .ql-dot-inner { background: ${G.accent} !important; }

// //   /* table row */
// //   .tbl-row { transition: background .15s; cursor: pointer; }
// //   .tbl-row:hover { background: rgba(255,255,255,.025); }

// //   /* logout */
// //   .logout-btn { transition: all .2s; }
// //   .logout-btn:hover { background: rgba(239,68,68,.18) !important; border-color: rgba(239,68,68,.45) !important; }

// //   /* collapse animation */
// //   .collapse-items {
// //     overflow: hidden;
// //     max-height: 0;
// //     transition: max-height .38s cubic-bezier(.4,0,.2,1);
// //   }
// //   .collapse-items.open { max-height: 2400px; }

// //   /* fade-up */
// //   @keyframes fadeUp { from{opacity:0;transform:translateY(14px)} to{opacity:1;transform:translateY(0)} }
// //   .fade-up { animation: fadeUp .35s ease both; }
// //   .fade-up-1{animation-delay:.05s} .fade-up-2{animation-delay:.1s}
// //   .fade-up-3{animation-delay:.15s} .fade-up-4{animation-delay:.2s}

// //   /* section arrow */
// //   .sec-arrow { transition: transform .25s, background .2s; }
// //   .sec-arrow.open { transform: rotate(90deg) !important; background: ${G.accentGlow} !important; color: ${G.accent} !important; }
// // `;

// // /* ─── Nav data ───────────────────────────────────────────────────────────── */
// // const NAV_SECTIONS = [
// //   {
// //     id: 'appdata', label: 'View App Data', emoji: '📊',
// //     items: [
// //       { label: 'Users Profile',        to: '/users_profile' },
// //       { label: 'Portfolio',            to: '/portfolio_data' },
// //       { label: 'Portfolio Analyser',   to: '/portfolio_analyser' },
// //       { label: 'Portfolio Reviews',    to: '/portfolio_reviews' },
// //       { label: 'Customer Data',        to: '/customer_data' },
// //       { label: 'Referred Courses',     to: '/referred_courses' },
// //       { label: "User's Location",      to: '/location_data' },
// //       { label: 'Website Message',      to: '/website_message' },
// //       { label: 'App Feedback',         to: '/app_feedback' },
// //       { label: 'Appointment Analyser', to: '/appointment_analyser' },
// //       { label: 'My Business',          to: '/my_business' },
// //       { label: 'Clicked Logs',         to: '/clicked_logs' },
// //       { label: 'All Certificates',     to: '/all_certificates' },
// //       { label: 'Workshop Feedback',    to: '/workshop_feedback' },
// //       { label: 'Workshops Payment',    to: '/workshop_payment' },
// //       { label: 'Expense List',         to: '/expenses_list' },
// //       { label: 'Registration Count',   to: '/workshop_registration_count' },
// //       { label: 'App Referral',         to: '/app_referral' },
// //       { label: 'Feedback Reply',       to: '/feedback_reply' },
// //       { label: 'Users Checkin',        to: '/user_last_checkin' },
// //       { label: 'Login Logs',           to: '/login_logs' },
// //       { label: 'Downloaded Cert.',     to: '/downloaded_certificate' },
// //       { label: 'Topic Request',        to: '/topic_request' },
// //     ],
// //   },
// //   {
// //     id: 'requests', label: 'View All Requests', emoji: '📨',
// //     items: [
// //       { label: 'Beauty Kit Requests',      to: '/beauty_kit_requests' },
// //       { label: 'Upcoming Session',         to: '/upcoming_session' },
// //       { label: 'Book Demo Requests',       to: '/book_demo_requests' },
// //       { label: 'Hire Requests',            to: '/hire_request' },
// //       { label: 'Event Requests',           to: '/event_request' },
// //       { label: 'Loan Requests',            to: '/loan_request' },
// //       { label: 'Loan Remarks',             to: '/loan_remark' },
// //       { label: 'Workshop Registration',    to: '/workshop_registration' },
// //       { label: 'Workshop Payment',         to: '/workshop_payment' },
// //       { label: 'All Workshop',             to: '/workshop' },
// //       { label: 'Workshop Query',           to: '/workshop_query' },
// //       { label: 'Workshop Event Request',   to: '/workshop_event_request' },
// //       { label: 'Delete Portfolio Req.',    to: '/delete_portfolio_req' },
// //       { label: 'Advertise Feedback',       to: '/advertise_feedback' },
// //     ],
// //   },
// //   {
// //     id: 'create', label: 'Create', emoji: '✏️',
// //     items: [
// //       { label: 'Guidance Session',         to: '/guidance_session' },
// //       { label: 'Workshop',                 to: '/workshop_data' },
// //       { label: 'Workshop Hindi',           to: '/workshop_data_hindi' },
// //       { label: 'Workshop Reminder',        to: '/workshop_reminder' },
// //       { label: 'Pin Workshop',             to: '/pin_workshop' },
// //       { label: 'Workshop Attendance',      to: '/workshop_attendance' },
// //       { label: 'Workshop Glimpses',        to: '/workshop_glimpses' },
// //       { label: 'Attendance Status',        to: '/workshop_attendance_status' },
// //       { label: 'Upload Recorded Session',  to: '/upload_recorded_video' },
// //       { label: 'Upload Certificate',       to: '/upload_certificates' },
// //       { label: 'Send Whatsapp',            to: '/send_whatsapp' },
// //       { label: 'Create Whatsapp Template', to: '/create_whatsapp_template' },
// //       { label: 'Courses',                  to: '/course_data' },
// //       { label: 'Course Hindi',             to: '/course_data_hindi' },
// //       { label: 'Add Slider Images',        to: '/add_slider_images' },
// //       { label: 'Add Workshop Slider',      to: '/workshop_slider_image' },
// //       { label: 'Add Global Notification',  to: '/global_notification' },
// //       { label: 'Advertise Download',       to: '/advertise_download' },
// //       { label: 'After Session Slider',     to: '/session_slider_images' },
// //       { label: 'Workshop Code',            to: '/workshop_code' },
// //       { label: 'Workshop Tag',             to: '/workshop_tag' },
// //       { label: 'Add Adv Slider',           to: '/advertise_slider' },
// //     ],
// //   },
// //   {
// //     id: 'new', label: 'New', emoji: '🆕',
// //     items: [
// //       { label: 'Upload Course',            to: '/CourseUploadForm' },
// //       { label: 'Add Quiz',                 to: '/add_quiz' },
// //       { label: 'Add Expert',               to: '/add_expert' },
// //       { label: 'Add Enrollment',           to: '/custom_enrollment' },
// //       { label: 'View Course Enrollment',   to: '/course_enrollment' },
// //       { label: 'Membership Data',          to: '/membership_tracking' },
// //       { label: 'Booking',                  to: '/bookings' },
// //       { label: 'Add Doubt Sessions',       to: '/add_doubt_session' },
// //       { label: 'Doubt Sessions Data',      to: '/doubt_session' },
// //       { label: 'Community',                to: '/community' },
// //       { label: 'App Queries',              to: '/query_data' },
// //       { label: 'Faqs Query',               to: '/faqs_query' },
// //       { label: 'Profile Type',             to: '/profile_type' },
// //       { label: 'Course Video Update',      to: '/course_video_update' },
// //       { label: 'Course Attendance Update', to: '/course_attendance_update' },
// //       { label: 'Course Timestamp Update',  to: '/course_timestamp_update' },
// //       { label: 'Booked Appointments',      to: '/appointment_booked' },
// //       { label: 'Appointment Analyser',     to: '/appointment_analyser' },
// //       { label: 'Finance Query',            to: '/finance_query' },
// //       { label: 'Certificate Download',     to: '/certificate_downloads' },
// //       { label: 'Course Report',            to: '/users_course_data' },
// //       { label: 'Analytics Preview',        to: '/analytics_preview' },
// //       { label: 'Log Analytics',            to: '/dashbaordall' },
// //       { label: 'Homepage Banner',          to: '/apptopbanner' },
// //       { label: 'Homepage Poster',          to: '/homepage_poster' },
// //       { label: 'Transaction History',      to: '/transaction_history' },
// //       { label: 'Requested Topics',         to: '/requested_topics' },
// //       { label: 'Know More About Course',   to: '/know_more_about_course' },
// //       { label: 'Active Members',           to: '/active_membership' },
// //       { label: 'Certificate Data',         to: '/downloaded_certificate_data' },
// //       { label: 'Workshop Registration',    to: '/workshop_registrations' },
// //       { label: 'Udyam Registration',       to: '/UdyamRegistrationData' },
// //       { label: 'Ecommerce Support Data',   to: '/EcommerceSupportData' },
// //       { label: 'Edit Course',              to: '/editcoursepage' },
// //       { label: 'Hindi Workshop Name',      to: '/workshophindiversion' },
// //     ],
// //   },
// //   {
// //     id: 'grow', label: 'Grow', emoji: '🌱',
// //     items: [
// //       { label: 'Call Back Request', to: '/call_back_request' },
// //       { label: 'Grow Data',         to: '/grow_all_data' },
// //       { label: 'Ready Made Delete', to: '/readymadepage' },
// //       { label: 'DIY Delete',        to: '/diycardpage' },
// //       { label: 'Studio Requests',   to: '/orders_data' },
// //     ],
// //   },
// // ];

// // const RECENT_REQUESTS = [
// //   { user: 'Priya Sharma',   type: 'Book Demo',             date: 'Today, 10:24 AM',      status: 'Pending',   statusClass: 'yellow' },
// //   { user: 'Rohan Mehta',    type: 'Workshop Registration', date: 'Today, 9:12 AM',       status: 'Confirmed', statusClass: 'green'  },
// //   { user: 'Anita Joshi',    type: 'Hire Request',          date: 'Yesterday, 5:40 PM',   status: 'In Review', statusClass: 'blue'   },
// //   { user: 'Vikram Das',     type: 'Loan Request',          date: 'Yesterday, 2:10 PM',   status: 'Rejected',  statusClass: 'red'    },
// //   { user: 'Sunita Kapoor',  type: 'Beauty Kit',            date: 'May 3, 11:00 AM',      status: 'Fulfilled', statusClass: 'green'  },
// // ];

// // const BADGE_COLORS = {
// //   green:  { bg: 'rgba(34,197,94,.12)',  color: '#22c55e' },
// //   yellow: { bg: 'rgba(245,158,11,.12)', color: '#f59e0b' },
// //   blue:   { bg: 'rgba(56,189,248,.1)',  color: '#38bdf8' },
// //   red:    { bg: 'rgba(239,68,68,.1)',   color: '#ef4444' },
// // };

// // /* ─── Sub-components ─────────────────────────────────────────────────────── */

// // function NavSection({ section, activeLink, setActiveLink }) {
// //   const [open, setOpen] = useState(false);

// //   return (
// //     <div>
// //       {/* Section header */}
// //       <div
// //         className="sec-header"
// //         onClick={() => setOpen(o => !o)}
// //         style={{
// //           display: 'flex', alignItems: 'center', justifyContent: 'space-between',
// //           padding: '16px 20px 8px', cursor: 'pointer', userSelect: 'none',
// //         }}
// //       >
// //         <span
// //           className="sec-label"
// //           style={{
// //             fontSize: 10.5, fontWeight: 700, letterSpacing: '.12em',
// //             textTransform: 'uppercase', color: G.textMuted, transition: 'color .2s',
// //           }}
// //         >
// //           {section.emoji}&nbsp; {section.label}
// //         </span>
// //         <span
// //           className={`sec-arrow${open ? ' open' : ''}`}
// //           style={{
// //             width: 18, height: 18,
// //             background: G.surface2,
// //             borderRadius: 5,
// //             display: 'flex', alignItems: 'center', justifyContent: 'center',
// //             fontSize: 12, color: G.textMuted,
// //           }}
// //         >
// //           ›
// //         </span>
// //       </div>

// //       {/* Collapsible items */}
// //       <div className={`collapse-items${open ? ' open' : ''}`}>
// //         {section.items.map(item => (
// //           <Link
// //             key={item.to}
// //             to={item.to}
// //             className={`nav-item-link${activeLink === item.to ? ' active-link' : ''}`}
// //             onClick={() => setActiveLink(item.to)}
// //             style={{
// //               display: 'flex', alignItems: 'center', gap: 10,
// //               padding: '7px 20px 7px 30px',
// //               color: G.textSecondary,
// //               fontSize: 13, fontWeight: 400,
// //               textDecoration: 'none',
// //               position: 'relative',
// //             }}
// //           >
// //             <span
// //               className="nav-dot"
// //               style={{
// //                 width: 5, height: 5, borderRadius: '50%',
// //                 background: G.textMuted, flexShrink: 0, transition: 'background .2s',
// //               }}
// //             />
// //             {item.label}
// //           </Link>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // }

// // function StatCard({ icon, value, label, change, changeUp, colorClass, delay }) {
// //   const topColors = {
// //     purple: 'linear-gradient(90deg,#6c63ff,#a78bfa)',
// //     teal:   'linear-gradient(90deg,#00d4aa,#34d399)',
// //     amber:  'linear-gradient(90deg,#f59e0b,#fbbf24)',
// //     sky:    'linear-gradient(90deg,#38bdf8,#7dd3fc)',
// //   };
// //   const iconBgs = {
// //     purple: G.accentGlow,
// //     teal:   'rgba(0,212,170,.12)',
// //     amber:  'rgba(245,158,11,.12)',
// //     sky:    'rgba(56,189,248,.1)',
// //   };

// //   return (
// //     <div
// //       className={`stat-card fade-up fade-up-${delay}`}
// //       style={{
// //         background: G.surface,
// //         border: `1px solid ${G.border}`,
// //         borderRadius: 14,
// //         padding: 20,
// //         position: 'relative',
// //         overflow: 'hidden',
// //       }}
// //     >
// //       {/* top accent line */}
// //       <div style={{
// //         position: 'absolute', top: 0, left: 0, right: 0, height: 2,
// //         background: topColors[colorClass],
// //       }} />
// //       <div style={{
// //         width: 40, height: 40, borderRadius: 10,
// //         background: iconBgs[colorClass],
// //         display: 'flex', alignItems: 'center', justifyContent: 'center',
// //         fontSize: 18, marginBottom: 14,
// //       }}>
// //         {icon}
// //       </div>
// //       <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 28, fontWeight: 700, lineHeight: 1 }}>
// //         {value}
// //       </div>
// //       <div style={{ fontSize: 12.5, color: G.textSecondary, marginTop: 6, fontWeight: 500 }}>
// //         {label}
// //       </div>
// //       <div style={{
// //         fontSize: 11.5, marginTop: 10, display: 'flex', alignItems: 'center', gap: 4,
// //         color: changeUp ? G.success : G.danger,
// //       }}>
// //         {changeUp ? '↑' : '↓'} {change}
// //       </div>
// //     </div>
// //   );
// // }

// // function QuickSection({ title, badge, items }) {
// //   return (
// //     <div style={{
// //       background: G.surface, border: `1px solid ${G.border}`,
// //       borderRadius: 14, padding: 20,
// //     }}>
// //       <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
// //         <div style={{ fontSize: 14, fontWeight: 600 }}>{title}</div>
// //         <div style={{
// //           fontSize: 11, padding: '3px 8px', borderRadius: 6,
// //           background: G.surface2, color: G.textSecondary,
// //         }}>
// //           {badge}
// //         </div>
// //       </div>
// //       <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
// //         {items.map(item => (
// //           <div
// //             key={item}
// //             className="ql-pill"
// //             style={{
// //               padding: '6px 12px',
// //               background: G.surface2,
// //               border: `1px solid ${G.border}`,
// //               borderRadius: 8,
// //               fontSize: 12,
// //               color: G.textSecondary,
// //               cursor: 'pointer',
// //               display: 'flex', alignItems: 'center', gap: 6,
// //             }}
// //           >
// //             <span className="ql-dot-inner" style={{
// //               width: 5, height: 5, borderRadius: '50%',
// //               background: G.textMuted, flexShrink: 0,
// //             }} />
// //             {item}
// //           </div>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // }

// // /* ─── Main Component ─────────────────────────────────────────────────────── */

// // function AdminPanel() {
// //   const navigate = useNavigate();
// //   const [totalCount, setTotalCount] = useState('—');
// //   const [activeLink, setActiveLink] = useState('');

// //   /* inject global CSS once */
// //   useEffect(() => {
// //     const id = 'admin-panel-styles';
// //     if (!document.getElementById(id)) {
// //       const style = document.createElement('style');
// //       style.id = id;
// //       style.textContent = globalCss;
// //       document.head.appendChild(style);
// //     }
// //     return () => {
// //       const el = document.getElementById(id);
// //       if (el) el.remove();
// //     };
// //   }, []);

// //   /* auth guard */
// //   useEffect(() => {
// //     const email    = localStorage.getItem('email');
// //     const password = localStorage.getItem('password');
// //     const remember = localStorage.getItem('remember');
// //     if (remember === 'false' || !email || !password) navigate('/signin');
// //   }, [navigate]);

// //   /* fetch total count */
// //   useEffect(() => {
// //     const fetchData = async () => {
// //       try {
// //         const snapshot = await getDocs(collection(db, 'personal_details'));
// //         setTotalCount(snapshot.size.toLocaleString('en-IN'));
// //       } catch (err) {
// //         console.error('Error fetching data:', err);
// //       }
// //     };
// //     fetchData();
// //   }, []);

// //   const logout = () => {
// //     localStorage.removeItem('email');
// //     localStorage.removeItem('password');
// //     localStorage.removeItem('remember');
// //     navigate('/signin');
// //   };

// //   return (
// //     <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: G.bgDark }}>

// //       {/* ── SIDEBAR ── */}
// //       <aside style={{
// //         width: 260, minWidth: 260,
// //         background: G.sidebarBg,
// //         borderRight: `1px solid ${G.sidebarBorder}`,
// //         display: 'flex', flexDirection: 'column', overflow: 'hidden',
// //       }}>

// //         {/* Brand */}
// //         <div style={{
// //           padding: '20px 20px 16px',
// //           display: 'flex', alignItems: 'center', gap: 12,
// //           borderBottom: `1px solid ${G.border}`, flexShrink: 0,
// //         }}>
// //           <div style={{
// //             width: 36, height: 36,
// //             background: 'linear-gradient(135deg,#6c63ff,#a78bfa)',
// //             borderRadius: 10,
// //             display: 'flex', alignItems: 'center', justifyContent: 'center',
// //             fontSize: 16, flexShrink: 0,
// //           }}>
// //             ⚡
// //           </div>
// //           <div>
// //             <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 15, fontWeight: 700 }}>
// //               AdminPanel
// //             </div>
// //             <div style={{ fontSize: 11, color: G.textSecondary }}>Management Console</div>
// //           </div>
// //         </div>

// //         {/* Nav scroll */}
// //         <nav style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', padding: '10px 0 16px' }}>
// //           {NAV_SECTIONS.map(sec => (
// //             <NavSection
// //               key={sec.id}
// //               section={sec}
// //               activeLink={activeLink}
// //               setActiveLink={setActiveLink}
// //             />
// //           ))}

// //           {/* Logout */}
// //           <div style={{ padding: '12px 16px 0' }}>
// //             <button
// //               className="logout-btn"
// //               onClick={logout}
// //               style={{
// //                 width: '100%', padding: '10px 16px',
// //                 display: 'flex', alignItems: 'center', gap: 10,
// //                 background: 'rgba(239,68,68,.08)',
// //                 border: '1px solid rgba(239,68,68,.18)',
// //                 borderRadius: 10,
// //                 color: G.danger,
// //                 fontSize: 13, fontWeight: 500,
// //                 cursor: 'pointer',
// //               }}
// //             >
// //               <span>⎋</span> Logout
// //             </button>
// //           </div>
// //         </nav>

// //         {/* Footer user row */}
// //         <div style={{ padding: '14px 16px', borderTop: `1px solid ${G.border}`, flexShrink: 0 }}>
// //           <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
// //             <div style={{
// //               width: 32, height: 32,
// //               background: 'linear-gradient(135deg,#6c63ff,#00d4aa)',
// //               borderRadius: 9,
// //               display: 'flex', alignItems: 'center', justifyContent: 'center',
// //               fontSize: 13, fontWeight: 700, color: '#fff', flexShrink: 0,
// //             }}>A</div>
// //             <div>
// //               <div style={{ fontSize: 13, fontWeight: 600 }}>Admin</div>
// //               <div style={{ fontSize: 11, color: G.textMuted }}>Super Admin</div>
// //             </div>
// //             <div style={{
// //               marginLeft: 'auto',
// //               width: 7, height: 7, borderRadius: '50%',
// //               background: G.success,
// //               boxShadow: `0 0 6px ${G.success}`,
// //             }} />
// //           </div>
// //         </div>
// //       </aside>

// //       {/* ── MAIN ── */}
// //       <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

// //         {/* Topbar */}
// //         <header style={{
// //           height: 60,
// //           background: G.surface,
// //           borderBottom: `1px solid ${G.border}`,
// //           display: 'flex', alignItems: 'center',
// //           padding: '0 28px', gap: 16, flexShrink: 0,
// //         }}>
// //           <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 16, fontWeight: 600, flex: 1 }}>
// //             Dashboard Overview
// //           </div>
// //           <div style={{
// //             background: G.accentGlow, color: G.accent,
// //             padding: '4px 12px', borderRadius: 20,
// //             fontSize: 12, fontWeight: 500,
// //             border: '1px solid rgba(108,99,255,.25)',
// //           }}>
// //             ● Live
// //           </div>
// //           <div style={{ fontSize: 12, color: G.textSecondary }}>
// //             {new Date().toLocaleDateString('en-IN', { month: 'short', year: 'numeric' })}
// //           </div>
// //           <div style={{
// //             width: 34, height: 34,
// //             background: 'linear-gradient(135deg,#6c63ff,#00d4aa)',
// //             borderRadius: 10,
// //             display: 'flex', alignItems: 'center', justifyContent: 'center',
// //             fontSize: 13, fontWeight: 700, color: '#fff', cursor: 'pointer',
// //           }}>A</div>
// //         </header>

// //         {/* Scrollable content */}
// //         <main style={{ flex: 1, overflowY: 'auto', padding: 28 }}>

// //           {/* Page heading */}
// //           <div style={{ marginBottom: 28 }}>
// //             <h1 style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 24, fontWeight: 700 }}>
// //               Welcome back, Admin 👋
// //             </h1>
// //             <p style={{ color: G.textSecondary, fontSize: 13.5, marginTop: 4 }}>
// //               Here's what's happening with your platform today.
// //             </p>
// //           </div>

// //           {/* Stat cards */}
// //           <div style={{
// //             display: 'grid',
// //             gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
// //             gap: 16, marginBottom: 28,
// //           }}>
// //             <StatCard icon="📱" value={totalCount}  label="App Downloads"          change="12% from last month" changeUp delay={1} colorClass="purple" />
// //             <StatCard icon="🎓" value="148"          label="Workshop Registrations"  change="8% this week"       changeUp delay={2} colorClass="teal"   />
// //             <StatCard icon="📋" value="34"           label="Pending Requests"        change="5 new today"        changeUp delay={3} colorClass="amber"  />
// //             <StatCard icon="🏆" value="209"          label="Certificates Issued"     change="3% this month"      changeUp delay={4} colorClass="sky"    />
// //           </div>

// //           {/* Quick section cards */}
// //           <div style={{
// //             display: 'grid', gridTemplateColumns: '1fr 1fr',
// //             gap: 20, marginBottom: 28,
// //           }}>
// //             <QuickSection title="📊 App Data"   badge={`${NAV_SECTIONS[0].items.length} sections`}
// //               items={NAV_SECTIONS[0].items.slice(0,8).map(i => i.label)} />
// //             <QuickSection title="📨 Requests"   badge={`${NAV_SECTIONS[1].items.length} sections`}
// //               items={NAV_SECTIONS[1].items.slice(0,8).map(i => i.label)} />
// //             <QuickSection title="✏️ Create"     badge={`${NAV_SECTIONS[2].items.length} sections`}
// //               items={NAV_SECTIONS[2].items.slice(0,8).map(i => i.label)} />
// //             <QuickSection title="🆕 New / Grow" badge={`${NAV_SECTIONS[3].items.length + NAV_SECTIONS[4].items.length} sections`}
// //               items={[...NAV_SECTIONS[3].items, ...NAV_SECTIONS[4].items].slice(0,8).map(i => i.label)} />
// //           </div>

// //           {/* Recent requests table */}
// //           <div style={{
// //             background: G.surface, border: `1px solid ${G.border}`,
// //             borderRadius: 14, overflow: 'hidden',
// //           }}>
// //             <div style={{
// //               padding: '16px 20px',
// //               borderBottom: `1px solid ${G.border}`,
// //               display: 'flex', alignItems: 'center', justifyContent: 'space-between',
// //             }}>
// //               <div style={{ fontSize: 14, fontWeight: 600 }}>Recent Requests</div>
// //               <div style={{ fontSize: 12, color: G.accent, cursor: 'pointer' }}>View all →</div>
// //             </div>
// //             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
// //               <thead>
// //                 <tr style={{ background: G.surface2, borderBottom: `1px solid ${G.border}` }}>
// //                   {['User', 'Request Type', 'Date', 'Status'].map(h => (
// //                     <th key={h} style={{
// //                       padding: '10px 20px', textAlign: 'left',
// //                       fontSize: 11, fontWeight: 600, letterSpacing: '.07em',
// //                       textTransform: 'uppercase', color: G.textMuted,
// //                     }}>{h}</th>
// //                   ))}
// //                 </tr>
// //               </thead>
// //               <tbody>
// //                 {RECENT_REQUESTS.map((row, i) => {
// //                   const bc = BADGE_COLORS[row.statusClass];
// //                   return (
// //                     <tr
// //                       key={i}
// //                       className="tbl-row"
// //                       style={{ borderBottom: i < RECENT_REQUESTS.length - 1 ? `1px solid ${G.border}` : 'none' }}
// //                     >
// //                       <td style={{ padding: '12px 20px', fontSize: 13, color: G.textPrimary, fontWeight: 500 }}>{row.user}</td>
// //                       <td style={{ padding: '12px 20px', fontSize: 13, color: G.textSecondary }}>{row.type}</td>
// //                       <td style={{ padding: '12px 20px', fontSize: 13, color: G.textSecondary }}>{row.date}</td>
// //                       <td style={{ padding: '12px 20px' }}>
// //                         <span style={{
// //                           display: 'inline-block', padding: '3px 9px', borderRadius: 6,
// //                           fontSize: 11, fontWeight: 600,
// //                           background: bc.bg, color: bc.color,
// //                         }}>{row.status}</span>
// //                       </td>
// //                     </tr>
// //                   );
// //                 })}
// //               </tbody>
// //             </table>
// //           </div>

// //           {/* bottom spacer */}
// //           <div style={{ height: 24 }} />
// //         </main>
// //       </div>
// //     </div>
// //   );
// // }

// // export default AdminPanel;


import React, { useState, useEffect } from 'react';

import { useNavigate, Link, useParams } from 'react-router-dom';
import db from "./Firebase";
import { collection, getDocs, query, limit } from 'firebase/firestore/lite';
import Moment from 'moment';
import { extendMoment } from 'moment-range';

function AdminPanel() {
    const navigate = useNavigate();
    const moment = extendMoment(Moment);
    const [activeIndex, setActiveIndex] = useState(null);
    const [showAppData, setShowAppData] = useState(false);
    const [showRequestData, setShowRequestData] = useState(false);
    const [showCreateData, setShowCreateData] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showGrow, setShowGrow] = useState(false);
    const [view, setView] = useState(false);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const tabData = [
        { label: 'View App Data', content: 'Content 1' },
        { label: 'View All Requests', content: 'Content 2' },
    ];


    const [totalCount, setTotalCount] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const snapshot = await getDocs(collection(db, "personal_details"));
                const count = snapshot.size; // Get the total count
                setTotalCount(count);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);


    const logout = () => {
        localStorage.removeItem("email");
        localStorage.removeItem("password");
        localStorage.removeItem("remember");
        navigate('/signin')
    };

    useEffect(() => {
        const storedUsername = localStorage.getItem("email");
        const storedPassword = localStorage.getItem("password");
        const storedRemember = localStorage.getItem("remember");

        if (storedRemember === "false" || !storedUsername || !storedPassword) {
            navigate('/signin');
        }
    }, []);






    return (
        <>
            <div id="wrapper">


                <div id="sidebar-wrapper">
                    <ul class="sidebar-nav">
                        <span style={{ cursor: "pointer" }} class=" text-white" > <li class="nav-item mt-3">
                            <h6 class=" text-uppercase text-xs text-white font-weight-bolder">Home</h6>
                        </li>
                        </span>
                        {/* <Link class={activeIndex === 21 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/" onClick={() => setActiveIndex(21)}>
                            <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div>
                            <span class="nav-link-text ms-1">Portfolio Analyser</span>
                        </Link> */}
                        {/* <Link class={activeIndex === 22 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/" onClick={() => setActiveIndex(22)}>
                            <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div>
                            <span class="nav-link-text ms-1">Portfolio Reviews</span>
                        </Link> */}
                        {/* <Link class={activeIndex === 23 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/" onClick={() => setActiveIndex(23)}>
                            <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div>
                            <span class="nav-link-text ms-1">All Appointments</span>
                        </Link> */}
                        <span style={{ cursor: "pointer" }} class=" text-white" to="/" onClick={() => showAppData ? setShowAppData(false) : setShowAppData(true)}> <li class="nav-item mt-3">
                            <h6 class=" text-uppercase text-xs text-white font-weight-bolder">View App Data {showAppData ? <><i class="fa fa-arrow-down ml-4" aria-hidden="true"></i></> : <><i class="fa fa-arrow-right ml-4" aria-hidden="true"></i></>}</h6>
                        </li>
                        </span>




                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 7 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/users_profile">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Users Profile</span>
                            </Link>
                        </li> </> : null}
                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 8 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/portfolio_data">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Portfolio</span>
                            </Link>
                        </li> </> : null}

                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 8 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/portfolio_analyser">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Portfolio Analyser</span>
                            </Link>
                        </li> </> : null}


                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 8 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/portfolio_reviews">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Portfolio Reviews</span>
                            </Link>
                        </li> </> : null}
                        {/* 
                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 28 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/portfolio_full_data">
                            
                                <span class="nav-link-text ms-1">Portfolio All Data</span>
                            </Link>
                        </li> </> : null} */}
                        {/* 
                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 8 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/appointments">
                              
                                <span class="nav-link-text ms-1">All Appointments</span>
                            </Link>
                        </li> </> : null} */}





                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 9 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/customer_data">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Customer Data</span>
                            </Link>
                        </li> </> : null}

                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 10 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/referred_courses">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Referred Courses</span>
                            </Link>
                        </li> </> : null}





                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 28 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/location_data">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">User's Location</span>
                            </Link>
                        </li> </> : null}



                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 39 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/website_message">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Website Message</span>
                            </Link>
                        </li> </> : null}

                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 39 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/app_feedback">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">App Feedback</span>
                            </Link>
                        </li> </> : null}

                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 40 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/appointment_analyser">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Appointment Analyser</span>
                            </Link>
                        </li> </> : null}

                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 41 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/my_business">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">My Business</span>
                            </Link>
                        </li> </> : null}

                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 49 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/clicked_logs">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Clicked Logs</span>
                            </Link>
                        </li> </> : null}

                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 79 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/all_certificates">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">All Certificates</span>
                            </Link>
                        </li> </> : null}

                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 89 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_feedback">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Workshop Feedback</span>
                            </Link>
                        </li> </> : null}

                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 899 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_payment">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Workshops Payment</span>
                            </Link>
                        </li> </> : null}

                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 99 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/expenses_list">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Expense List</span>
                            </Link>
                        </li> </> : null}

                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 991 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_registration_count">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Registration Count</span>
                            </Link>
                        </li> </> : null}
                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 9931 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/app_referral">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">App Referral</span>
                            </Link>
                        </li> </> : null}

                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 9932 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/feedback_reply">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Feedback Reply</span>
                            </Link>
                        </li> </> : null}

                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 9932 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/user_last_checkin">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Users Checkin</span>
                            </Link>
                        </li> </> : null}

                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 9932 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/login_logs">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Login Logs</span>
                            </Link>
                        </li> </> : null}

                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 9932 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/downloaded_certificate">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Downloaded Cert.</span>
                            </Link>
                        </li> </> : null}


                        {showAppData ? <><li class="nav-item">
                            <Link class={activeIndex === 9939 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/topic_request">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Topic Request</span>
                            </Link>
                        </li> </> : null}





                        <span style={{ cursor: "pointer" }} class=" text-white" to="/" onClick={() => showRequestData ? setShowRequestData(false) : setShowRequestData(true)}>   <li class="nav-item mt-3">
                            <h6 class=" text-uppercase text-xs text-white font-weight-bolder">View All request {showRequestData ? <><i class="fa fa-arrow-down ml-4" aria-hidden="true"></i></> : <><i class="fa fa-arrow-right ml-4" aria-hidden="true"></i></>}</h6>
                        </li> </span>
                        {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 11 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/beauty_kit_requests">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">table_view</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Beauty Kit Requests</span>
                            </Link>
                        </li> </> : null}

                        {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 1199 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/upcoming_session">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">table_view</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Upcoming Session</span>
                            </Link>
                        </li> </> : null}


                        {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 12 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/book_demo_requests">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">receipt_long</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Book Demo Requests</span>
                            </Link>
                        </li> </> : null}
                        {/* {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 13 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/business_card_request" >
                                <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">view_in_ar</i>
                                </div>
                                <span class="nav-link-text ms-1">Business card Requests</span>
                            </Link>
                        </li> </> : null} */}
                        {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 14 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/hire_request">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Hire Requests</span>
                            </Link>
                        </li> </> : null}
                        {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 14 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/event_request">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Event Requests</span>
                            </Link>
                        </li> </> : null}
                        {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 15 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/loan_request">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">notifications</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Loan Requests</span>
                            </Link>
                        </li> </> : null}
                        {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 15 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/loan_remark">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">notifications</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Loan Remarks</span>
                            </Link>
                        </li> </> : null}
                        {/* {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 16 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/premium_card_request">
                              
                                <span class="nav-link-text ms-1">Premium Card Req.</span>
                            </Link>
                        </li> </> : null} */}

                        {/* {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 16 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/premium_smg_request">
                             
                                <span class="nav-link-text ms-1">Premium SMG Req.</span>
                            </Link>
                        </li> </> : null} */}


                        {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 17 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_registration">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Workshop Registration</span>
                            </Link>
                        </li> </> : null}
                        {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 17 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_payment">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Workshop Payment</span>
                            </Link>
                        </li> </> : null}

                        {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 18 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">All Workshop</span>
                            </Link>
                        </li> </> : null}

                        {showRequestData ? <><li class="nav-item">
                            <Link class={activeIndex === 59 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_query">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Workshop Query</span>
                            </Link>
                        </li> </> : null}

                        {showRequestData ? <><li class="nav-item">
                            <Link class={activeIndex === 59 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_event_request">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Workshop Event Request</span>
                            </Link>
                        </li> </> : null}



                        {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 20 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/delete_portfolio_req">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Delete Portfolio Req.</span>
                            </Link>
                        </li> </> : null}

                        {/* {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 116 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/banner_request">
                            
                                <span class="nav-link-text ms-1">Banner Request</span>
                            </Link>
                        </li> </> : null} */}

                        {/* {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 116 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/premium_banner_request">
                                
                                <span class="nav-link-text ms-1">Premium Banner Request</span>
                            </Link>
                        </li> </> : null} */}

                        {/* {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 117 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/smg_request">
                             
                                <span class="nav-link-text ms-1">SMG Request</span>
                            </Link>
                        </li> </> : null} */}

                        {/* {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 118 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/whatsapp_business_request">
                           
                                <span class="nav-link-text ms-1">WB Request</span>
                            </Link>
                        </li> </> : null} */}
                        {/* 
                        {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 119 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/google_business_request">
                              
                                <span class="nav-link-text ms-1">GB Request</span>
                            </Link>
                        </li> </> : null} */}


                        {showRequestData ? <> <li class="nav-item">
                            <Link class={activeIndex === 120 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/advertise_feedback">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Advertise Feedback</span>
                            </Link>
                        </li> </> : null}





                        <span style={{ cursor: "pointer" }} class=" text-white" to="/" onClick={() => showCreateData ? setShowCreateData(false) : setShowCreateData(true)}>   <li class="nav-item mt-3">
                            <h6 class=" text-uppercase text-xs text-white font-weight-bolder">Create {showCreateData ? <><i class="fa fa-arrow-down ml-4" aria-hidden="true"></i></> : <><i class="fa fa-arrow-right ml-4" aria-hidden="true"></i></>}</h6>
                        </li> </span>

                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 5 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/guidance_session">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">notifications</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Guidance Session</span>
                            </Link>
                        </li> </> : null}

                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 5 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_data">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">notifications</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Workshop</span>
                            </Link>
                        </li> </> : null}

                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 6 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_data_hindi">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Workshop Hindi</span>
                            </Link>
                        </li> </> : null}

                        {showCreateData ? <> <li class="nav-item">
                            <Link class={activeIndex === 48 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_reminder">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Workshop Reminder</span>
                            </Link>
                        </li> </> : null}

                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 60 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/pin_workshop">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Pin Workshop</span>
                            </Link>
                        </li> </> : null}

                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 61 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_attendance">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Workshop Attendance</span>
                            </Link>
                        </li> </> : null}


                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 689 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_glimpses">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Workshop Glimpses</span>
                            </Link>
                        </li> </> : null}

                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 62 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_attendance_status">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Attendance Status </span>
                            </Link>
                        </li> </> : null}


                        {showCreateData ? <> <li class="nav-item">
                            <Link class={activeIndex === 22 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/upload_recorded_video">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Upload Recorded Session</span>
                            </Link>
                        </li> </> : null}


                        {showCreateData ? <> <li class="nav-item">
                            <Link class={activeIndex === 58 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/upload_certificates">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Upload Certificate</span>
                            </Link>
                        </li> </> : null}




                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 10 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/send_whatsapp">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Send Whatsapp</span>
                            </Link>
                        </li> </> : null}

                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 10 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/create_whatsapp_template">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Create Whatsapp Template</span>
                            </Link>
                        </li> </> : null}

                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 0 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/course_data" >
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">dashboard</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Courses</span>
                            </Link>
                        </li> </> : null}
                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 1 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/course_data_hindi">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">table_view</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Course Hindi</span>
                            </Link>
                        </li> </> : null}

                        {/* {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 2 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/promotional_data">
                             
                                <span class="nav-link-text ms-1">Create an Offer (premade)</span>
                            </Link>
                        </li> </> : null}

                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 1225 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/custom_cards">
                           
                                <span class="nav-link-text ms-1">Create an Offer (custom) </span>
                            </Link>
                        </li> </> : null} */}
                        {/* {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 3 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/freebusinesscards_data">
                            
                                <span class="nav-link-text ms-1">Add Free Vist. Cards</span>
                            </Link>
                        </li> </> : null} */}
                        {/* {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 4 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/premiumcards_data">
                             
                                <span class="nav-link-text ms-1">Premium Cards</span>
                            </Link>
                        </li> </> : null} */}

                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 38 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/add_slider_images">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Add Slider Images</span>
                            </Link>
                        </li> </> : null}

                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 78 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_slider_image">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Add Workshop Slider</span>
                            </Link>
                        </li> </> : null}

                        {/* {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 111 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/banner_design">
                              
                                <span class="nav-link-text ms-1">Add Free Banner Design</span>
                            </Link>
                        </li> </> : null} */}

                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 112 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/global_notification">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Add Global Notification</span>
                            </Link>
                        </li> </> : null}

                        {/* {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 113 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/previous_card_work">
                              
                                <span class="nav-link-text ms-1">Add Prem. Vist Cards</span>
                            </Link>
                        </li> </> : null} */}



                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 115 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/advertise_download">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Advertise Download</span>
                            </Link>
                        </li> </> : null}

                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 115 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/session_slider_images">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">After Session Slider</span>
                            </Link>
                        </li> </> : null}


                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 1225 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_code">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Workshop Code</span>
                            </Link>
                        </li> </> : null}


                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 1225 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_tag">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Workshop Tag</span>
                            </Link>
                        </li> </> : null}

                        {/* {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 1225 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/social_media_graphics">
                             
                                <span class="nav-link-text ms-1">Add Free SMG</span>
                            </Link>
                        </li> </> : null} */}

                        {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 1225 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/advertise_slider">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Add Adv Slider</span>
                            </Link>
                        </li> </> : null}

                        {/* {showCreateData ? <><li class="nav-item">
                            <Link class={activeIndex === 1225 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/previous_sm">
                         
                                <span class="nav-link-text ms-1">Add Prem SMG </span>
                            </Link>
                        </li> </> : null} */}





                        <span style={{ cursor: "pointer" }} class=" text-white" to="/" onClick={() => showNew ? setShowNew(false) : setShowNew(true)}>   <li class="nav-item mt-3">
                            <h6 class=" text-uppercase text-xs text-white font-weight-bolder">New {showNew ? <><i class="fa fa-arrow-down ml-4" aria-hidden="true"></i></> : <><i class="fa fa-arrow-right ml-4" aria-hidden="true"></i></>}</h6>
                        </li> </span>


                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 5 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/CourseUploadForm">

                                <span class="nav-link-text ms-1">Upload Course</span>
                            </Link>
                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/add_quiz">

                                <span class="nav-link-text ms-1">Add Quiz</span>
                            </Link>
                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/add_expert">

                                <span class="nav-link-text ms-1">Add Expert</span>
                            </Link>
                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/custom_enrollment">

                                <span class="nav-link-text ms-1">Add Enrollment</span>
                            </Link>
                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/course_enrollment">

                                <span class="nav-link-text ms-1">View Course Enrollment</span>
                            </Link>
                        </li> </> : null}


                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/membership_tracking">

                                <span class="nav-link-text ms-1">Membership Data</span>
                            </Link>
                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/bookings">

                                <span class="nav-link-text ms-1">Booking</span>
                            </Link>
                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/add_doubt_session">

                                <span class="nav-link-text ms-1">Add Doubt Sessions</span>
                            </Link>
                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/doubt_session">

                                <span class="nav-link-text ms-1">Doubt Sessions data</span>
                            </Link>
                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/community">

                                <span class="nav-link-text ms-1">Community</span>
                            </Link>
                        </li> </> : null}

                        {/* {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/call_back_request">

                                <span class="nav-link-text ms-1">Call back request</span>
                            </Link>
                        </li> </> : null} */}



                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/query_data">

                                <span class="nav-link-text ms-1">App Queries</span>
                            </Link>
                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/faqs_query">

                                <span class="nav-link-text ms-1">Faqs Query</span>
                            </Link>
                        </li> </> : null}

                        {/* {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/studio_review">

                                <span class="nav-link-text ms-1">Studio Reviews</span>
                            </Link>
                        </li> </> : null} */}



                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/profile_type">

                                <span class="nav-link-text ms-1">Profile Type</span>
                            </Link>
                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/course_video_update">

                                <span class="nav-link-text ms-1">Course Video Update</span>
                            </Link>
                        </li> </> : null}


                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/course_attendance_update">

                                <span class="nav-link-text ms-1">Course Attendance Update</span>
                            </Link>
                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/course_timestamp_update">

                                <span class="nav-link-text ms-1">Course Timestamp Update</span>
                            </Link>
                        </li> </> : null}


                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 8 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/appointment_booked">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Booked Appointments</span>
                            </Link>
                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 40 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/appointment_analyser">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Appointment Analyser</span>
                            </Link>
                        </li> </> : null}


                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 40 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/finance_query">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Finance Query</span>
                            </Link>
                        </li> </> : null}



                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 40 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/certificate_downloads">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Certificate Download</span>
                            </Link>
                        </li> </> : null}


                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 40 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/users_course_data">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Course Report</span>
                            </Link>
                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 40 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/analytics_preview">
                                <span class="nav-link-text ms-1">Analytics Preview</span>
                            </Link>
                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 40 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/dashbaordall">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Log Analytics</span>
                            </Link>
                        </li> </> : null}
                        {/* {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 40 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/add_growcard">
                               
                                <span class="nav-link-text ms-1">Add DIY</span>
                            </Link>
                        </li> </> : null} */}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 40 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/apptopbanner">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Homepage Banner</span>
                            </Link>
                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 61 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/homepage_poster">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Homepage Poster</span>
                            </Link>
                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 62 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/transaction_history">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Transaction History</span>
                            </Link>
                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 63 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/requested_topics">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Requested Topics</span>
                            </Link>
                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/know_more_about_course">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Know More About Course</span>
                            </Link>

                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/active_membership">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Active Members</span>
                            </Link>

                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/downloaded_certificate_data">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Certificate Data</span>
                            </Link>

                        </li> </> : null}


                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_registrations">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Workshop Registration</span>
                            </Link>

                        </li> </> : null}


                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/UdyamRegistrationData">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Udyam Registration</span>
                            </Link>

                        </li> </> : null}


                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/EcommerceSupportData">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Ecommerce Support Data</span>
                            </Link>

                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/editcoursepage">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Edit Course</span>
                            </Link>

                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshophindiversion">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Hindi Workshop Name</span>
                            </Link>

                        </li> </> : null}

                        {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/invoice_data">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Invoices</span>
                            </Link>

                        </li> </> : null}

                         {showNew ? <><li class="nav-item">
                            <Link class={activeIndex === 69 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_join_event">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Workshop Join Event</span>
                            </Link>

                        </li> </> : null}















                        <span style={{ cursor: "pointer" }} class=" text-white" to="/" onClick={() => showGrow ? setShowGrow(false) : setShowGrow(true)}>   <li class="nav-item mt-3">
                            <h6 class=" text-uppercase text-xs text-white font-weight-bolder">Grow {showGrow ? <><i class="fa fa-arrow-down ml-4" aria-hidden="true"></i></> : <><i class="fa fa-arrow-right ml-4" aria-hidden="true"></i></>}</h6>
                        </li> </span>

                        {showGrow ? <> <li class="nav-item">
                            <Link class={activeIndex === 19 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/call_back_request">
                                {/* <Link class={activeIndex === 19 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/request_callback">call_back_request */}
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">Call Back Request</span>
                            </Link>
                        </li> </> : null}


                        {showGrow ? <><li class="nav-item">
                            <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/grow_all_data">

                                <span class="nav-link-text ms-1">Grow Data</span>
                            </Link>
                        </li> </> : null}

                        {showGrow ? <><li class="nav-item">
                            <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/readymadepage">

                                <span class="nav-link-text ms-1">Ready Made Delete</span>
                            </Link>

                        </li> </> : null}


                        {showGrow ? <><li class="nav-item">
                            <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/diycardpage">
                                {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
                                </div> */}
                                <span class="nav-link-text ms-1">DIY Delete</span>
                            </Link>

                        </li> </> : null}



                        {showGrow ? <><li class="nav-item">
                            <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/orders_data">

                                <span class="nav-link-text ms-1">Studio Requests</span>
                            </Link>
                        </li> </> : null}



                        {/* {showCreateData ? <> <li class="nav-item">
                            <Link class={activeIndex === 60 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/push_notifications">
                              
                                <span class="nav-link-text ms-1">Push Notification</span>
                            </Link>
                        </li> </> : null} */}

                        <span style={{ cursor: "pointer" }} class=" text-white" onClick={() => logout()}> <li class="nav-item mt-3">
                            <h6 class=" text-uppercase text-xs text-white font-weight-bolder">Logout <i class="fa fa-sign-out ml-4" aria-hidden="true" style={{ "fontSize": "20px", "color": "white" }}></i></h6>
                        </li>
                        </span>

                        <li class="nav-item">
                            <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                <i class="material-icons opacity-10"></i>
                            </div>
                            <span class="nav-link-text ms-1"></span>
                        </li>
                        <li class="nav-item">
                            {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                <i class="material-icons opacity-10"></i>
                            </div> */}
                            <span class="nav-link-text ms-1"></span>
                        </li>
                        <li class="nav-item">
                            {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                <i class="material-icons opacity-10"></i>
                            </div> */}
                            <span class="nav-link-text ms-1"></span>
                        </li>
                        <li class="nav-item">
                            {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
                                <i class="material-icons opacity-10"></i>
                            </div> */}
                            <span class="nav-link-text ms-1"></span>
                        </li>




                    </ul>
                </div>

                <div class="card" style={{ padding: "2rem" }}>
                    <div class="card-header p-2 pt-1" style={{ borderStyle: "none" }}>
                        <div
                            class="icon-md icon-shape bg-gradient-dark shadow-dark text-center border-radius-xl mt-n4 position-absolute">
                            <i class="material-icons opacity-10">weekend</i>
                        </div>
                        <div class="text-end pt-1">
                            <p class="mb-0 text-capitalize" style={{ fontWeight: "bold", fontSize: "13.1px" }}>Apps Download</p>
                            <h4 class="mb-0" style={{ fontWeight: "700", fontSize: "22px" }}>{totalCount}</h4>
                        </div>
                    </div>
                    <hr class="dark horizontal my-0" />

                </div>

                <div style={{ display: "flex", justifyContent: "center" }}>
                    <img src="/images/adminpanel.jpg" class="menu-toggle" alt="Responsive image" style={{ height: "38rem" }} />
                </div>


            </div>
        </>
    )
}

export default AdminPanel;



// // import React, { useState, useEffect } from 'react';
// // import { useNavigate, Link } from 'react-router-dom';
// // import db from './Firebase';
// // import { collection, getDocs } from 'firebase/firestore/lite';

// // /* ─── Inline styles ─────────────────────────────────────────────────────── */
// // const G = {
// //   /* palette — light theme */
// //   bgDark:       '#f0f2f7',       // page background
// //   sidebarBg:    '#ffffff',       // sidebar white
// //   sidebarBorder:'#e4e7f0',
// //   surface:      '#ffffff',       // card white
// //   surface2:     '#f5f7fb',       // table header / inner bg
// //   accent:       '#6c63ff',
// //   accentGlow:   'rgba(108,99,255,0.10)',
// //   accent2:      '#00b894',
// //   textPrimary:  '#1a1d2e',
// //   textSecondary:'#6b7280',
// //   textMuted:    '#9ca3af',
// //   success:      '#16a34a',
// //   warning:      '#d97706',
// //   danger:       '#dc2626',
// //   info:         '#0284c7',
// //   border:       '#e4e7f0',
// // };

// // const globalCss = `
// //   @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=Space+Grotesk:wght@400;500;600;700&display=swap');

// //   *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
// //   html, body { height: 100%; background: ${G.bgDark}; color: ${G.textPrimary};
// //     font-family: 'DM Sans', sans-serif; overflow: hidden; }

// //   /* scrollbars */
// //   ::-webkit-scrollbar { width: 4px; }
// //   ::-webkit-scrollbar-track { background: transparent; }
// //   ::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 2px; }

// //   /* nav item hover */
// //   .nav-item-link { transition: all .15s; }
// //   .nav-item-link:hover { color: ${G.accent} !important; background: ${G.accentGlow} !important; }
// //   .nav-item-link:hover .nav-dot { background: ${G.accent} !important; }
// //   .nav-item-link.active-link { color: ${G.accent} !important; background: ${G.accentGlow} !important; }
// //   .nav-item-link.active-link .nav-dot { background: ${G.accent} !important; }

// //   /* section header hover */
// //   .sec-header:hover .sec-label { color: ${G.textPrimary} !important; }

// //   /* stat card hover */
// //   .stat-card { transition: transform .2s, box-shadow .2s; }
// //   .stat-card:hover { transform: translateY(-2px); box-shadow: 0 10px 32px rgba(108,99,255,.12); }

// //   /* quick link hover */
// //   .ql-pill { transition: all .15s; }
// //   .ql-pill:hover { border-color: ${G.accent} !important; color: ${G.accent} !important;
// //     background: ${G.accentGlow} !important; }
// //   .ql-pill:hover .ql-dot-inner { background: ${G.accent} !important; }

// //   /* table row */
// //   .tbl-row { transition: background .15s; cursor: pointer; }
// //   .tbl-row:hover { background: ${G.surface2}; }

// //   /* logout */
// //   .logout-btn { transition: all .2s; }
// //   .logout-btn:hover { background: rgba(220,38,38,.12) !important; border-color: rgba(220,38,38,.4) !important; }

// //   /* collapse animation */
// //   .collapse-items {
// //     overflow: hidden;
// //     max-height: 0;
// //     transition: max-height .38s cubic-bezier(.4,0,.2,1);
// //   }
// //   .collapse-items.open { max-height: 2400px; }

// //   /* fade-up */
// //   @keyframes fadeUp { from{opacity:0;transform:translateY(14px)} to{opacity:1;transform:translateY(0)} }
// //   .fade-up { animation: fadeUp .35s ease both; }
// //   .fade-up-1{animation-delay:.05s} .fade-up-2{animation-delay:.1s}
// //   .fade-up-3{animation-delay:.15s} .fade-up-4{animation-delay:.2s}

// //   /* section arrow */
// //   .sec-arrow { transition: transform .25s, background .2s; }
// //   .sec-arrow.open { transform: rotate(90deg) !important; background: ${G.accentGlow} !important; color: ${G.accent} !important; }
// // `;

// // /* ─── Nav data ───────────────────────────────────────────────────────────── */
// // const NAV_SECTIONS = [
// //   {
// //     id: 'appdata', label: 'View App Data', emoji: '📊',
// //     items: [
// //       { label: 'Users Profile',        to: '/users_profile' },
// //       { label: 'Portfolio',            to: '/portfolio_data' },
// //       { label: 'Portfolio Analyser',   to: '/portfolio_analyser' },
// //       { label: 'Portfolio Reviews',    to: '/portfolio_reviews' },
// //       { label: 'Customer Data',        to: '/customer_data' },
// //       { label: 'Referred Courses',     to: '/referred_courses' },
// //       { label: "User's Location",      to: '/location_data' },
// //       { label: 'Website Message',      to: '/website_message' },
// //       { label: 'App Feedback',         to: '/app_feedback' },
// //       { label: 'Appointment Analyser', to: '/appointment_analyser' },
// //       { label: 'My Business',          to: '/my_business' },
// //       { label: 'Clicked Logs',         to: '/clicked_logs' },
// //       { label: 'All Certificates',     to: '/all_certificates' },
// //       { label: 'Workshop Feedback',    to: '/workshop_feedback' },
// //       { label: 'Workshops Payment',    to: '/workshop_payment' },
// //       { label: 'Expense List',         to: '/expenses_list' },
// //       { label: 'Registration Count',   to: '/workshop_registration_count' },
// //       { label: 'App Referral',         to: '/app_referral' },
// //       { label: 'Feedback Reply',       to: '/feedback_reply' },
// //       { label: 'Users Checkin',        to: '/user_last_checkin' },
// //       { label: 'Login Logs',           to: '/login_logs' },
// //       { label: 'Downloaded Cert.',     to: '/downloaded_certificate' },
// //       { label: 'Topic Request',        to: '/topic_request' },
// //     ],
// //   },
// //   {
// //     id: 'requests', label: 'View All Requests', emoji: '📨',
// //     items: [
// //       { label: 'Beauty Kit Requests',      to: '/beauty_kit_requests' },
// //       { label: 'Upcoming Session',         to: '/upcoming_session' },
// //       { label: 'Book Demo Requests',       to: '/book_demo_requests' },
// //       { label: 'Hire Requests',            to: '/hire_request' },
// //       { label: 'Event Requests',           to: '/event_request' },
// //       { label: 'Loan Requests',            to: '/loan_request' },
// //       { label: 'Loan Remarks',             to: '/loan_remark' },
// //       { label: 'Workshop Registration',    to: '/workshop_registration' },
// //       { label: 'Workshop Payment',         to: '/workshop_payment' },
// //       { label: 'All Workshop',             to: '/workshop' },
// //       { label: 'Workshop Query',           to: '/workshop_query' },
// //       { label: 'Workshop Event Request',   to: '/workshop_event_request' },
// //       { label: 'Delete Portfolio Req.',    to: '/delete_portfolio_req' },
// //       { label: 'Advertise Feedback',       to: '/advertise_feedback' },
// //     ],
// //   },
// //   {
// //     id: 'create', label: 'Create', emoji: '✏️',
// //     items: [
// //       { label: 'Guidance Session',         to: '/guidance_session' },
// //       { label: 'Workshop',                 to: '/workshop_data' },
// //       { label: 'Workshop Hindi',           to: '/workshop_data_hindi' },
// //       { label: 'Workshop Reminder',        to: '/workshop_reminder' },
// //       { label: 'Pin Workshop',             to: '/pin_workshop' },
// //       { label: 'Workshop Attendance',      to: '/workshop_attendance' },
// //       { label: 'Workshop Glimpses',        to: '/workshop_glimpses' },
// //       { label: 'Attendance Status',        to: '/workshop_attendance_status' },
// //       { label: 'Upload Recorded Session',  to: '/upload_recorded_video' },
// //       { label: 'Upload Certificate',       to: '/upload_certificates' },
// //       { label: 'Send Whatsapp',            to: '/send_whatsapp' },
// //       { label: 'Create Whatsapp Template', to: '/create_whatsapp_template' },
// //       { label: 'Courses',                  to: '/course_data' },
// //       { label: 'Course Hindi',             to: '/course_data_hindi' },
// //       { label: 'Add Slider Images',        to: '/add_slider_images' },
// //       { label: 'Add Workshop Slider',      to: '/workshop_slider_image' },
// //       { label: 'Add Global Notification',  to: '/global_notification' },
// //       { label: 'Advertise Download',       to: '/advertise_download' },
// //       { label: 'After Session Slider',     to: '/session_slider_images' },
// //       { label: 'Workshop Code',            to: '/workshop_code' },
// //       { label: 'Workshop Tag',             to: '/workshop_tag' },
// //       { label: 'Add Adv Slider',           to: '/advertise_slider' },
// //     ],
// //   },
// //   {
// //     id: 'new', label: 'New', emoji: '🆕',
// //     items: [
// //       { label: 'Upload Course',            to: '/CourseUploadForm' },
// //       { label: 'Add Quiz',                 to: '/add_quiz' },
// //       { label: 'Add Expert',               to: '/add_expert' },
// //       { label: 'Add Enrollment',           to: '/custom_enrollment' },
// //       { label: 'View Course Enrollment',   to: '/course_enrollment' },
// //       { label: 'Membership Data',          to: '/membership_tracking' },
// //       { label: 'Booking',                  to: '/bookings' },
// //       { label: 'Add Doubt Sessions',       to: '/add_doubt_session' },
// //       { label: 'Doubt Sessions Data',      to: '/doubt_session' },
// //       { label: 'Community',                to: '/community' },
// //       { label: 'App Queries',              to: '/query_data' },
// //       { label: 'Faqs Query',               to: '/faqs_query' },
// //       { label: 'Profile Type',             to: '/profile_type' },
// //       { label: 'Course Video Update',      to: '/course_video_update' },
// //       { label: 'Course Attendance Update', to: '/course_attendance_update' },
// //       { label: 'Course Timestamp Update',  to: '/course_timestamp_update' },
// //       { label: 'Booked Appointments',      to: '/appointment_booked' },
// //       { label: 'Appointment Analyser',     to: '/appointment_analyser' },
// //       { label: 'Finance Query',            to: '/finance_query' },
// //       { label: 'Certificate Download',     to: '/certificate_downloads' },
// //       { label: 'Course Report',            to: '/users_course_data' },
// //       { label: 'Analytics Preview',        to: '/analytics_preview' },
// //       { label: 'Log Analytics',            to: '/dashbaordall' },
// //       { label: 'Homepage Banner',          to: '/apptopbanner' },
// //       { label: 'Homepage Poster',          to: '/homepage_poster' },
// //       { label: 'Transaction History',      to: '/transaction_history' },
// //       { label: 'Requested Topics',         to: '/requested_topics' },
// //       { label: 'Know More About Course',   to: '/know_more_about_course' },
// //       { label: 'Active Members',           to: '/active_membership' },
// //       { label: 'Certificate Data',         to: '/downloaded_certificate_data' },
// //       { label: 'Workshop Registration',    to: '/workshop_registrations' },
// //       { label: 'Udyam Registration',       to: '/UdyamRegistrationData' },
// //       { label: 'Ecommerce Support Data',   to: '/EcommerceSupportData' },
// //       { label: 'Edit Course',              to: '/editcoursepage' },
// //       { label: 'Hindi Workshop Name',      to: '/workshophindiversion' },
// //     ],
// //   },
// //   {
// //     id: 'grow', label: 'Grow', emoji: '🌱',
// //     items: [
// //       { label: 'Call Back Request', to: '/call_back_request' },
// //       { label: 'Grow Data',         to: '/grow_all_data' },
// //       { label: 'Ready Made Delete', to: '/readymadepage' },
// //       { label: 'DIY Delete',        to: '/diycardpage' },
// //       { label: 'Studio Requests',   to: '/orders_data' },
// //     ],
// //   },
// // ];

// // const RECENT_REQUESTS = [
// //   { user: 'Priya Sharma',   type: 'Book Demo',             date: 'Today, 10:24 AM',      status: 'Pending',   statusClass: 'yellow' },
// //   { user: 'Rohan Mehta',    type: 'Workshop Registration', date: 'Today, 9:12 AM',       status: 'Confirmed', statusClass: 'green'  },
// //   { user: 'Anita Joshi',    type: 'Hire Request',          date: 'Yesterday, 5:40 PM',   status: 'In Review', statusClass: 'blue'   },
// //   { user: 'Vikram Das',     type: 'Loan Request',          date: 'Yesterday, 2:10 PM',   status: 'Rejected',  statusClass: 'red'    },
// //   { user: 'Sunita Kapoor',  type: 'Beauty Kit',            date: 'May 3, 11:00 AM',      status: 'Fulfilled', statusClass: 'green'  },
// // ];

// // const BADGE_COLORS = {
// //   green:  { bg: 'rgba(34,197,94,.12)',  color: '#22c55e' },
// //   yellow: { bg: 'rgba(245,158,11,.12)', color: '#f59e0b' },
// //   blue:   { bg: 'rgba(56,189,248,.1)',  color: '#38bdf8' },
// //   red:    { bg: 'rgba(239,68,68,.1)',   color: '#ef4444' },
// // };

// // /* ─── Sub-components ─────────────────────────────────────────────────────── */

// // function NavSection({ section, activeLink, setActiveLink }) {
// //   const [open, setOpen] = useState(false);

// //   return (
// //     <div>
// //       {/* Section header */}
// //       <div
// //         className="sec-header"
// //         onClick={() => setOpen(o => !o)}
// //         style={{
// //           display: 'flex', alignItems: 'center', justifyContent: 'space-between',
// //           padding: '16px 20px 8px', cursor: 'pointer', userSelect: 'none',
// //         }}
// //       >
// //         <span
// //           className="sec-label"
// //           style={{
// //             fontSize: 10.5, fontWeight: 700, letterSpacing: '.12em',
// //             textTransform: 'uppercase', color: G.textMuted, transition: 'color .2s',
// //           }}
// //         >
// //           {section.emoji}&nbsp; {section.label}
// //         </span>
// //         <span
// //           className={`sec-arrow${open ? ' open' : ''}`}
// //           style={{
// //             width: 18, height: 18,
// //             background: G.surface2,
// //             borderRadius: 5,
// //             display: 'flex', alignItems: 'center', justifyContent: 'center',
// //             fontSize: 12, color: G.textMuted,
// //           }}
// //         >
// //           ›
// //         </span>
// //       </div>

// //       {/* Collapsible items */}
// //       <div className={`collapse-items${open ? ' open' : ''}`}>
// //         {section.items.map(item => (
// //           <Link
// //             key={item.to}
// //             to={item.to}
// //             className={`nav-item-link${activeLink === item.to ? ' active-link' : ''}`}
// //             onClick={() => setActiveLink(item.to)}
// //             style={{
// //               display: 'flex', alignItems: 'center', gap: 10,
// //               padding: '7px 20px 7px 30px',
// //               color: G.textSecondary,
// //               fontSize: 13, fontWeight: 400,
// //               textDecoration: 'none',
// //               position: 'relative',
// //             }}
// //           >
// //             <span
// //               className="nav-dot"
// //               style={{
// //                 width: 5, height: 5, borderRadius: '50%',
// //                 background: G.textMuted, flexShrink: 0, transition: 'background .2s',
// //               }}
// //             />
// //             {item.label}
// //           </Link>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // }

// // function StatCard({ icon, value, label, change, changeUp, colorClass, delay }) {
// //   const topColors = {
// //     purple: 'linear-gradient(90deg,#6c63ff,#a78bfa)',
// //     teal:   'linear-gradient(90deg,#00d4aa,#34d399)',
// //     amber:  'linear-gradient(90deg,#f59e0b,#fbbf24)',
// //     sky:    'linear-gradient(90deg,#38bdf8,#7dd3fc)',
// //   };
// //   const iconBgs = {
// //     purple: 'rgba(108,99,255,.1)',
// //     teal:   'rgba(0,184,148,.12)',
// //     amber:  'rgba(217,119,6,.1)',
// //     sky:    'rgba(2,132,199,.1)',
// //   };

// //   return (
// //     <div
// //       className={`stat-card fade-up fade-up-${delay}`}
// //       style={{
// //         background: G.surface,
// //         border: `1px solid ${G.border}`,
// //         borderRadius: 14,
// //         padding: 20,
// //         position: 'relative',
// //         overflow: 'hidden',
// //       }}
// //     >
// //       {/* top accent line */}
// //       <div style={{
// //         position: 'absolute', top: 0, left: 0, right: 0, height: 2,
// //         background: topColors[colorClass],
// //       }} />
// //       <div style={{
// //         width: 40, height: 40, borderRadius: 10,
// //         background: iconBgs[colorClass],
// //         display: 'flex', alignItems: 'center', justifyContent: 'center',
// //         fontSize: 18, marginBottom: 14,
// //       }}>
// //         {icon}
// //       </div>
// //       <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 28, fontWeight: 700, lineHeight: 1 }}>
// //         {value}
// //       </div>
// //       <div style={{ fontSize: 12.5, color: G.textSecondary, marginTop: 6, fontWeight: 500 }}>
// //         {label}
// //       </div>
// //       <div style={{
// //         fontSize: 11.5, marginTop: 10, display: 'flex', alignItems: 'center', gap: 4,
// //         color: changeUp ? G.success : G.danger,
// //       }}>
// //         {changeUp ? '↑' : '↓'} {change}
// //       </div>
// //     </div>
// //   );
// // }

// // function QuickSection({ title, badge, items }) {
// //   return (
// //     <div style={{
// //       background: G.surface, border: `1px solid ${G.border}`,
// //       borderRadius: 14, padding: 20,
// //     }}>
// //       <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
// //         <div style={{ fontSize: 14, fontWeight: 600 }}>{title}</div>
// //         <div style={{
// //           fontSize: 11, padding: '3px 8px', borderRadius: 6,
// //           background: G.surface2, color: G.textSecondary,
// //         }}>
// //           {badge}
// //         </div>
// //       </div>
// //       <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
// //         {items.map(item => (
// //           <div
// //             key={item}
// //             className="ql-pill"
// //             style={{
// //               padding: '6px 12px',
// //               background: G.surface2,
// //               border: `1px solid ${G.border}`,
// //               borderRadius: 8,
// //               fontSize: 12,
// //               color: G.textSecondary,
// //               cursor: 'pointer',
// //               display: 'flex', alignItems: 'center', gap: 6,
// //             }}
// //           >
// //             <span className="ql-dot-inner" style={{
// //               width: 5, height: 5, borderRadius: '50%',
// //               background: G.textMuted, flexShrink: 0,
// //             }} />
// //             {item}
// //           </div>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // }

// // /* ─── Main Component ─────────────────────────────────────────────────────── */

// // function AdminPanel() {
// //   const navigate = useNavigate();
// //   const [totalCount, setTotalCount] = useState('—');
// //   const [activeLink, setActiveLink] = useState('');

// //   /* inject global CSS once */
// //   useEffect(() => {
// //     const id = 'admin-panel-styles';
// //     if (!document.getElementById(id)) {
// //       const style = document.createElement('style');
// //       style.id = id;
// //       style.textContent = globalCss;
// //       document.head.appendChild(style);
// //     }
// //     return () => {
// //       const el = document.getElementById(id);
// //       if (el) el.remove();
// //     };
// //   }, []);

// //   /* auth guard */
// //   useEffect(() => {
// //     const email    = localStorage.getItem('email');
// //     const password = localStorage.getItem('password');
// //     const remember = localStorage.getItem('remember');
// //     if (remember === 'false' || !email || !password) navigate('/signin');
// //   }, [navigate]);

// //   /* fetch total count */
// //   useEffect(() => {
// //     const fetchData = async () => {
// //       try {
// //         const snapshot = await getDocs(collection(db, 'personal_details'));
// //         setTotalCount(snapshot.size.toLocaleString('en-IN'));
// //       } catch (err) {
// //         console.error('Error fetching data:', err);
// //       }
// //     };
// //     fetchData();
// //   }, []);

// //   const logout = () => {
// //     localStorage.removeItem('email');
// //     localStorage.removeItem('password');
// //     localStorage.removeItem('remember');
// //     navigate('/signin');
// //   };

// //   return (
// //     <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: G.bgDark }}>

// //       {/* ── SIDEBAR ── */}
// //       <aside style={{
// //         width: 260, minWidth: 260,
// //         background: G.sidebarBg,
// //         borderRight: `1px solid ${G.sidebarBorder}`,
// //         boxShadow: '2px 0 12px rgba(108,99,255,.06)',
// //         display: 'flex', flexDirection: 'column', overflow: 'hidden',
// //       }}>

// //         {/* Brand */}
// //         <div style={{
// //           padding: '20px 20px 16px',
// //           display: 'flex', alignItems: 'center', gap: 12,
// //           borderBottom: `1px solid ${G.border}`, flexShrink: 0,
// //         }}>
// //           <div style={{
// //             width: 36, height: 36,
// //             background: 'linear-gradient(135deg,#6c63ff,#a78bfa)',
// //             borderRadius: 10,
// //             display: 'flex', alignItems: 'center', justifyContent: 'center',
// //             fontSize: 16, flexShrink: 0,
// //           }}>
// //             ⚡
// //           </div>
// //           <div>
// //             <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 15, fontWeight: 700 }}>
// //               AdminPanel
// //             </div>
// //             <div style={{ fontSize: 11, color: G.textSecondary }}>Management Console</div>
// //           </div>
// //         </div>

// //         {/* Nav scroll */}
// //         <nav style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', padding: '10px 0 16px' }}>
// //           {NAV_SECTIONS.map(sec => (
// //             <NavSection
// //               key={sec.id}
// //               section={sec}
// //               activeLink={activeLink}
// //               setActiveLink={setActiveLink}
// //             />
// //           ))}

// //           {/* Logout */}
// //           <div style={{ padding: '12px 16px 0' }}>
// //             <button
// //               className="logout-btn"
// //               onClick={logout}
// //               style={{
// //                 width: '100%', padding: '10px 16px',
// //                 display: 'flex', alignItems: 'center', gap: 10,
// //                 background: 'rgba(239,68,68,.08)',
// //                 border: '1px solid rgba(239,68,68,.18)',
// //                 borderRadius: 10,
// //                 color: G.danger,
// //                 fontSize: 13, fontWeight: 500,
// //                 cursor: 'pointer',
// //               }}
// //             >
// //               <span>⎋</span> Logout
// //             </button>
// //           </div>
// //         </nav>

// //         {/* Footer user row */}
// //         <div style={{ padding: '14px 16px', borderTop: `1px solid ${G.border}`, flexShrink: 0 }}>
// //           <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
// //             <div style={{
// //               width: 32, height: 32,
// //               background: 'linear-gradient(135deg,#6c63ff,#00d4aa)',
// //               borderRadius: 9,
// //               display: 'flex', alignItems: 'center', justifyContent: 'center',
// //               fontSize: 13, fontWeight: 700, color: '#fff', flexShrink: 0,
// //             }}>A</div>
// //             <div>
// //               <div style={{ fontSize: 13, fontWeight: 600 }}>Admin</div>
// //               <div style={{ fontSize: 11, color: G.textMuted }}>Super Admin</div>
// //             </div>
// //             <div style={{
// //               marginLeft: 'auto',
// //               width: 7, height: 7, borderRadius: '50%',
// //               background: G.success,
// //               boxShadow: `0 0 6px ${G.success}`,
// //             }} />
// //           </div>
// //         </div>
// //       </aside>

// //       {/* ── MAIN ── */}
// //       <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

// //         {/* Topbar */}
// //         <header style={{
// //           height: 60,
// //           background: G.surface,
// //           borderBottom: `1px solid ${G.border}`,
// //           display: 'flex', alignItems: 'center',
// //           padding: '0 28px', gap: 16, flexShrink: 0,
// //         }}>
// //           <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 16, fontWeight: 600, flex: 1 }}>
// //             Dashboard Overview
// //           </div>
// //           <div style={{
// //             background: G.accentGlow, color: G.accent,
// //             padding: '4px 12px', borderRadius: 20,
// //             fontSize: 12, fontWeight: 500,
// //             border: '1px solid rgba(108,99,255,.25)',
// //           }}>
// //             ● Live
// //           </div>
// //           <div style={{ fontSize: 12, color: G.textSecondary }}>
// //             {new Date().toLocaleDateString('en-IN', { month: 'short', year: 'numeric' })}
// //           </div>
// //           <div style={{
// //             width: 34, height: 34,
// //             background: 'linear-gradient(135deg,#6c63ff,#00d4aa)',
// //             borderRadius: 10,
// //             display: 'flex', alignItems: 'center', justifyContent: 'center',
// //             fontSize: 13, fontWeight: 700, color: '#fff', cursor: 'pointer',
// //           }}>A</div>
// //         </header>

// //         {/* Scrollable content */}
// //         <main style={{ flex: 1, overflowY: 'auto', padding: 28 }}>

// //           {/* Page heading */}
// //           <div style={{ marginBottom: 28 }}>
// //             <h1 style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 24, fontWeight: 700 }}>
// //               Welcome back, Admin 👋
// //             </h1>
// //             <p style={{ color: G.textSecondary, fontSize: 13.5, marginTop: 4 }}>
// //               Here's what's happening with your platform today.
// //             </p>
// //           </div>

// //           {/* Stat cards */}
// //           <div style={{
// //             display: 'grid',
// //             gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
// //             gap: 16, marginBottom: 28,
// //           }}>
// //             <StatCard icon="📱" value={totalCount}  label="App Downloads"          change="12% from last month" changeUp delay={1} colorClass="purple" />
// //             <StatCard icon="🎓" value="148"          label="Workshop Registrations"  change="8% this week"       changeUp delay={2} colorClass="teal"   />
// //             <StatCard icon="📋" value="34"           label="Pending Requests"        change="5 new today"        changeUp delay={3} colorClass="amber"  />
// //             <StatCard icon="🏆" value="209"          label="Certificates Issued"     change="3% this month"      changeUp delay={4} colorClass="sky"    />
// //           </div>

// //           {/* Quick section cards */}
// //           <div style={{
// //             display: 'grid', gridTemplateColumns: '1fr 1fr',
// //             gap: 20, marginBottom: 28,
// //           }}>
// //             <QuickSection title="📊 App Data"   badge={`${NAV_SECTIONS[0].items.length} sections`}
// //               items={NAV_SECTIONS[0].items.slice(0,8).map(i => i.label)} />
// //             <QuickSection title="📨 Requests"   badge={`${NAV_SECTIONS[1].items.length} sections`}
// //               items={NAV_SECTIONS[1].items.slice(0,8).map(i => i.label)} />
// //             <QuickSection title="✏️ Create"     badge={`${NAV_SECTIONS[2].items.length} sections`}
// //               items={NAV_SECTIONS[2].items.slice(0,8).map(i => i.label)} />
// //             <QuickSection title="🆕 New / Grow" badge={`${NAV_SECTIONS[3].items.length + NAV_SECTIONS[4].items.length} sections`}
// //               items={[...NAV_SECTIONS[3].items, ...NAV_SECTIONS[4].items].slice(0,8).map(i => i.label)} />
// //           </div>

// //           {/* Recent requests table */}
// //           <div style={{
// //             background: G.surface, border: `1px solid ${G.border}`,
// //             borderRadius: 14, overflow: 'hidden',
// //           }}>
// //             <div style={{
// //               padding: '16px 20px',
// //               borderBottom: `1px solid ${G.border}`,
// //               display: 'flex', alignItems: 'center', justifyContent: 'space-between',
// //             }}>
// //               <div style={{ fontSize: 14, fontWeight: 600 }}>Recent Requests</div>
// //               <div style={{ fontSize: 12, color: G.accent, cursor: 'pointer' }}>View all →</div>
// //             </div>
// //             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
// //               <thead>
// //                 <tr style={{ background: G.surface2, borderBottom: `1px solid ${G.border}` }}>
// //                   {['User', 'Request Type', 'Date', 'Status'].map(h => (
// //                     <th key={h} style={{
// //                       padding: '10px 20px', textAlign: 'left',
// //                       fontSize: 11, fontWeight: 600, letterSpacing: '.07em',
// //                       textTransform: 'uppercase', color: G.textMuted,
// //                     }}>{h}</th>
// //                   ))}
// //                 </tr>
// //               </thead>
// //               <tbody>
// //                 {RECENT_REQUESTS.map((row, i) => {
// //                   const bc = BADGE_COLORS[row.statusClass];
// //                   return (
// //                     <tr
// //                       key={i}
// //                       className="tbl-row"
// //                       style={{ borderBottom: i < RECENT_REQUESTS.length - 1 ? `1px solid ${G.border}` : 'none' }}
// //                     >
// //                       <td style={{ padding: '12px 20px', fontSize: 13, color: G.textPrimary, fontWeight: 500 }}>{row.user}</td>
// //                       <td style={{ padding: '12px 20px', fontSize: 13, color: G.textSecondary }}>{row.type}</td>
// //                       <td style={{ padding: '12px 20px', fontSize: 13, color: G.textSecondary }}>{row.date}</td>
// //                       <td style={{ padding: '12px 20px' }}>
// //                         <span style={{
// //                           display: 'inline-block', padding: '3px 9px', borderRadius: 6,
// //                           fontSize: 11, fontWeight: 600,
// //                           background: bc.bg, color: bc.color,
// //                         }}>{row.status}</span>
// //                       </td>
// //                     </tr>
// //                   );
// //                 })}
// //               </tbody>
// //             </table>
// //           </div>

// //           {/* bottom spacer */}
// //           <div style={{ height: 24 }} />
// //         </main>
// //       </div>
// //     </div>
// //   );
// // }

// // export default AdminPanel;



// // // import React, { useState, useEffect } from 'react';
// // // import { useNavigate, Link } from 'react-router-dom';
// // // import db from './Firebase';
// // // import { collection, getDocs } from 'firebase/firestore/lite';

// // // /* ─── Inline styles ─────────────────────────────────────────────────────── */
// // // const G = {
// // //   /* palette */
// // //   bgDark:      '#0d0f14',
// // //   sidebarBg:   '#111318',
// // //   sidebarBorder:'#1e2130',
// // //   surface:     '#16191f',
// // //   surface2:    '#1c2030',
// // //   accent:      '#6c63ff',
// // //   accentGlow:  'rgba(108,99,255,0.15)',
// // //   accent2:     '#00d4aa',
// // //   textPrimary: '#e8eaf0',
// // //   textSecondary:'#7a8099',
// // //   textMuted:   '#454b62',
// // //   success:     '#22c55e',
// // //   warning:     '#f59e0b',
// // //   danger:      '#ef4444',
// // //   info:        '#38bdf8',
// // //   border:      '#1e2232',
// // // };

// // // const globalCss = `
// // //   @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=Space+Grotesk:wght@400;500;600;700&display=swap');

// // //   *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
// // //   html, body { height: 100%; background: ${G.bgDark}; color: ${G.textPrimary};
// // //     font-family: 'DM Sans', sans-serif; overflow: hidden; }

// // //   /* scrollbars */
// // //   ::-webkit-scrollbar { width: 4px; }
// // //   ::-webkit-scrollbar-track { background: transparent; }
// // //   ::-webkit-scrollbar-thumb { background: ${G.border}; border-radius: 2px; }

// // //   /* nav item hover */
// // //   .nav-item-link { transition: all .15s; }
// // //   .nav-item-link:hover { color: ${G.textPrimary} !important; background: rgba(255,255,255,.03) !important; }
// // //   .nav-item-link:hover .nav-dot { background: ${G.accent} !important; }
// // //   .nav-item-link.active-link { color: ${G.accent} !important; background: ${G.accentGlow} !important; }
// // //   .nav-item-link.active-link .nav-dot { background: ${G.accent} !important; }

// // //   /* section header hover */
// // //   .sec-header:hover .sec-label { color: ${G.textSecondary} !important; }

// // //   /* stat card hover */
// // //   .stat-card { transition: transform .2s, box-shadow .2s; }
// // //   .stat-card:hover { transform: translateY(-2px); box-shadow: 0 10px 32px rgba(0,0,0,.35); }

// // //   /* quick link hover */
// // //   .ql-pill { transition: all .15s; }
// // //   .ql-pill:hover { border-color: ${G.accent} !important; color: ${G.accent} !important;
// // //     background: ${G.accentGlow} !important; }
// // //   .ql-pill:hover .ql-dot-inner { background: ${G.accent} !important; }

// // //   /* table row */
// // //   .tbl-row { transition: background .15s; cursor: pointer; }
// // //   .tbl-row:hover { background: rgba(255,255,255,.025); }

// // //   /* logout */
// // //   .logout-btn { transition: all .2s; }
// // //   .logout-btn:hover { background: rgba(239,68,68,.18) !important; border-color: rgba(239,68,68,.45) !important; }

// // //   /* collapse animation */
// // //   .collapse-items {
// // //     overflow: hidden;
// // //     max-height: 0;
// // //     transition: max-height .38s cubic-bezier(.4,0,.2,1);
// // //   }
// // //   .collapse-items.open { max-height: 2400px; }

// // //   /* fade-up */
// // //   @keyframes fadeUp { from{opacity:0;transform:translateY(14px)} to{opacity:1;transform:translateY(0)} }
// // //   .fade-up { animation: fadeUp .35s ease both; }
// // //   .fade-up-1{animation-delay:.05s} .fade-up-2{animation-delay:.1s}
// // //   .fade-up-3{animation-delay:.15s} .fade-up-4{animation-delay:.2s}

// // //   /* section arrow */
// // //   .sec-arrow { transition: transform .25s, background .2s; }
// // //   .sec-arrow.open { transform: rotate(90deg) !important; background: ${G.accentGlow} !important; color: ${G.accent} !important; }
// // // `;

// // // /* ─── Nav data ───────────────────────────────────────────────────────────── */
// // // const NAV_SECTIONS = [
// // //   {
// // //     id: 'appdata', label: 'View App Data', emoji: '📊',
// // //     items: [
// // //       { label: 'Users Profile',        to: '/users_profile' },
// // //       { label: 'Portfolio',            to: '/portfolio_data' },
// // //       { label: 'Portfolio Analyser',   to: '/portfolio_analyser' },
// // //       { label: 'Portfolio Reviews',    to: '/portfolio_reviews' },
// // //       { label: 'Customer Data',        to: '/customer_data' },
// // //       { label: 'Referred Courses',     to: '/referred_courses' },
// // //       { label: "User's Location",      to: '/location_data' },
// // //       { label: 'Website Message',      to: '/website_message' },
// // //       { label: 'App Feedback',         to: '/app_feedback' },
// // //       { label: 'Appointment Analyser', to: '/appointment_analyser' },
// // //       { label: 'My Business',          to: '/my_business' },
// // //       { label: 'Clicked Logs',         to: '/clicked_logs' },
// // //       { label: 'All Certificates',     to: '/all_certificates' },
// // //       { label: 'Workshop Feedback',    to: '/workshop_feedback' },
// // //       { label: 'Workshops Payment',    to: '/workshop_payment' },
// // //       { label: 'Expense List',         to: '/expenses_list' },
// // //       { label: 'Registration Count',   to: '/workshop_registration_count' },
// // //       { label: 'App Referral',         to: '/app_referral' },
// // //       { label: 'Feedback Reply',       to: '/feedback_reply' },
// // //       { label: 'Users Checkin',        to: '/user_last_checkin' },
// // //       { label: 'Login Logs',           to: '/login_logs' },
// // //       { label: 'Downloaded Cert.',     to: '/downloaded_certificate' },
// // //       { label: 'Topic Request',        to: '/topic_request' },
// // //     ],
// // //   },
// // //   {
// // //     id: 'requests', label: 'View All Requests', emoji: '📨',
// // //     items: [
// // //       { label: 'Beauty Kit Requests',      to: '/beauty_kit_requests' },
// // //       { label: 'Upcoming Session',         to: '/upcoming_session' },
// // //       { label: 'Book Demo Requests',       to: '/book_demo_requests' },
// // //       { label: 'Hire Requests',            to: '/hire_request' },
// // //       { label: 'Event Requests',           to: '/event_request' },
// // //       { label: 'Loan Requests',            to: '/loan_request' },
// // //       { label: 'Loan Remarks',             to: '/loan_remark' },
// // //       { label: 'Workshop Registration',    to: '/workshop_registration' },
// // //       { label: 'Workshop Payment',         to: '/workshop_payment' },
// // //       { label: 'All Workshop',             to: '/workshop' },
// // //       { label: 'Workshop Query',           to: '/workshop_query' },
// // //       { label: 'Workshop Event Request',   to: '/workshop_event_request' },
// // //       { label: 'Delete Portfolio Req.',    to: '/delete_portfolio_req' },
// // //       { label: 'Advertise Feedback',       to: '/advertise_feedback' },
// // //     ],
// // //   },
// // //   {
// // //     id: 'create', label: 'Create', emoji: '✏️',
// // //     items: [
// // //       { label: 'Guidance Session',         to: '/guidance_session' },
// // //       { label: 'Workshop',                 to: '/workshop_data' },
// // //       { label: 'Workshop Hindi',           to: '/workshop_data_hindi' },
// // //       { label: 'Workshop Reminder',        to: '/workshop_reminder' },
// // //       { label: 'Pin Workshop',             to: '/pin_workshop' },
// // //       { label: 'Workshop Attendance',      to: '/workshop_attendance' },
// // //       { label: 'Workshop Glimpses',        to: '/workshop_glimpses' },
// // //       { label: 'Attendance Status',        to: '/workshop_attendance_status' },
// // //       { label: 'Upload Recorded Session',  to: '/upload_recorded_video' },
// // //       { label: 'Upload Certificate',       to: '/upload_certificates' },
// // //       { label: 'Send Whatsapp',            to: '/send_whatsapp' },
// // //       { label: 'Create Whatsapp Template', to: '/create_whatsapp_template' },
// // //       { label: 'Courses',                  to: '/course_data' },
// // //       { label: 'Course Hindi',             to: '/course_data_hindi' },
// // //       { label: 'Add Slider Images',        to: '/add_slider_images' },
// // //       { label: 'Add Workshop Slider',      to: '/workshop_slider_image' },
// // //       { label: 'Add Global Notification',  to: '/global_notification' },
// // //       { label: 'Advertise Download',       to: '/advertise_download' },
// // //       { label: 'After Session Slider',     to: '/session_slider_images' },
// // //       { label: 'Workshop Code',            to: '/workshop_code' },
// // //       { label: 'Workshop Tag',             to: '/workshop_tag' },
// // //       { label: 'Add Adv Slider',           to: '/advertise_slider' },
// // //     ],
// // //   },
// // //   {
// // //     id: 'new', label: 'New', emoji: '🆕',
// // //     items: [
// // //       { label: 'Upload Course',            to: '/CourseUploadForm' },
// // //       { label: 'Add Quiz',                 to: '/add_quiz' },
// // //       { label: 'Add Expert',               to: '/add_expert' },
// // //       { label: 'Add Enrollment',           to: '/custom_enrollment' },
// // //       { label: 'View Course Enrollment',   to: '/course_enrollment' },
// // //       { label: 'Membership Data',          to: '/membership_tracking' },
// // //       { label: 'Booking',                  to: '/bookings' },
// // //       { label: 'Add Doubt Sessions',       to: '/add_doubt_session' },
// // //       { label: 'Doubt Sessions Data',      to: '/doubt_session' },
// // //       { label: 'Community',                to: '/community' },
// // //       { label: 'App Queries',              to: '/query_data' },
// // //       { label: 'Faqs Query',               to: '/faqs_query' },
// // //       { label: 'Profile Type',             to: '/profile_type' },
// // //       { label: 'Course Video Update',      to: '/course_video_update' },
// // //       { label: 'Course Attendance Update', to: '/course_attendance_update' },
// // //       { label: 'Course Timestamp Update',  to: '/course_timestamp_update' },
// // //       { label: 'Booked Appointments',      to: '/appointment_booked' },
// // //       { label: 'Appointment Analyser',     to: '/appointment_analyser' },
// // //       { label: 'Finance Query',            to: '/finance_query' },
// // //       { label: 'Certificate Download',     to: '/certificate_downloads' },
// // //       { label: 'Course Report',            to: '/users_course_data' },
// // //       { label: 'Analytics Preview',        to: '/analytics_preview' },
// // //       { label: 'Log Analytics',            to: '/dashbaordall' },
// // //       { label: 'Homepage Banner',          to: '/apptopbanner' },
// // //       { label: 'Homepage Poster',          to: '/homepage_poster' },
// // //       { label: 'Transaction History',      to: '/transaction_history' },
// // //       { label: 'Requested Topics',         to: '/requested_topics' },
// // //       { label: 'Know More About Course',   to: '/know_more_about_course' },
// // //       { label: 'Active Members',           to: '/active_membership' },
// // //       { label: 'Certificate Data',         to: '/downloaded_certificate_data' },
// // //       { label: 'Workshop Registration',    to: '/workshop_registrations' },
// // //       { label: 'Udyam Registration',       to: '/UdyamRegistrationData' },
// // //       { label: 'Ecommerce Support Data',   to: '/EcommerceSupportData' },
// // //       { label: 'Edit Course',              to: '/editcoursepage' },
// // //       { label: 'Hindi Workshop Name',      to: '/workshophindiversion' },
// // //     ],
// // //   },
// // //   {
// // //     id: 'grow', label: 'Grow', emoji: '🌱',
// // //     items: [
// // //       { label: 'Call Back Request', to: '/call_back_request' },
// // //       { label: 'Grow Data',         to: '/grow_all_data' },
// // //       { label: 'Ready Made Delete', to: '/readymadepage' },
// // //       { label: 'DIY Delete',        to: '/diycardpage' },
// // //       { label: 'Studio Requests',   to: '/orders_data' },
// // //     ],
// // //   },
// // // ];

// // // const RECENT_REQUESTS = [
// // //   { user: 'Priya Sharma',   type: 'Book Demo',             date: 'Today, 10:24 AM',      status: 'Pending',   statusClass: 'yellow' },
// // //   { user: 'Rohan Mehta',    type: 'Workshop Registration', date: 'Today, 9:12 AM',       status: 'Confirmed', statusClass: 'green'  },
// // //   { user: 'Anita Joshi',    type: 'Hire Request',          date: 'Yesterday, 5:40 PM',   status: 'In Review', statusClass: 'blue'   },
// // //   { user: 'Vikram Das',     type: 'Loan Request',          date: 'Yesterday, 2:10 PM',   status: 'Rejected',  statusClass: 'red'    },
// // //   { user: 'Sunita Kapoor',  type: 'Beauty Kit',            date: 'May 3, 11:00 AM',      status: 'Fulfilled', statusClass: 'green'  },
// // // ];

// // // const BADGE_COLORS = {
// // //   green:  { bg: 'rgba(34,197,94,.12)',  color: '#22c55e' },
// // //   yellow: { bg: 'rgba(245,158,11,.12)', color: '#f59e0b' },
// // //   blue:   { bg: 'rgba(56,189,248,.1)',  color: '#38bdf8' },
// // //   red:    { bg: 'rgba(239,68,68,.1)',   color: '#ef4444' },
// // // };

// // // /* ─── Sub-components ─────────────────────────────────────────────────────── */

// // // function NavSection({ section, activeLink, setActiveLink }) {
// // //   const [open, setOpen] = useState(false);

// // //   return (
// // //     <div>
// // //       {/* Section header */}
// // //       <div
// // //         className="sec-header"
// // //         onClick={() => setOpen(o => !o)}
// // //         style={{
// // //           display: 'flex', alignItems: 'center', justifyContent: 'space-between',
// // //           padding: '16px 20px 8px', cursor: 'pointer', userSelect: 'none',
// // //         }}
// // //       >
// // //         <span
// // //           className="sec-label"
// // //           style={{
// // //             fontSize: 10.5, fontWeight: 700, letterSpacing: '.12em',
// // //             textTransform: 'uppercase', color: G.textMuted, transition: 'color .2s',
// // //           }}
// // //         >
// // //           {section.emoji}&nbsp; {section.label}
// // //         </span>
// // //         <span
// // //           className={`sec-arrow${open ? ' open' : ''}`}
// // //           style={{
// // //             width: 18, height: 18,
// // //             background: G.surface2,
// // //             borderRadius: 5,
// // //             display: 'flex', alignItems: 'center', justifyContent: 'center',
// // //             fontSize: 12, color: G.textMuted,
// // //           }}
// // //         >
// // //           ›
// // //         </span>
// // //       </div>

// // //       {/* Collapsible items */}
// // //       <div className={`collapse-items${open ? ' open' : ''}`}>
// // //         {section.items.map(item => (
// // //           <Link
// // //             key={item.to}
// // //             to={item.to}
// // //             className={`nav-item-link${activeLink === item.to ? ' active-link' : ''}`}
// // //             onClick={() => setActiveLink(item.to)}
// // //             style={{
// // //               display: 'flex', alignItems: 'center', gap: 10,
// // //               padding: '7px 20px 7px 30px',
// // //               color: G.textSecondary,
// // //               fontSize: 13, fontWeight: 400,
// // //               textDecoration: 'none',
// // //               position: 'relative',
// // //             }}
// // //           >
// // //             <span
// // //               className="nav-dot"
// // //               style={{
// // //                 width: 5, height: 5, borderRadius: '50%',
// // //                 background: G.textMuted, flexShrink: 0, transition: 'background .2s',
// // //               }}
// // //             />
// // //             {item.label}
// // //           </Link>
// // //         ))}
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // function StatCard({ icon, value, label, change, changeUp, colorClass, delay }) {
// // //   const topColors = {
// // //     purple: 'linear-gradient(90deg,#6c63ff,#a78bfa)',
// // //     teal:   'linear-gradient(90deg,#00d4aa,#34d399)',
// // //     amber:  'linear-gradient(90deg,#f59e0b,#fbbf24)',
// // //     sky:    'linear-gradient(90deg,#38bdf8,#7dd3fc)',
// // //   };
// // //   const iconBgs = {
// // //     purple: G.accentGlow,
// // //     teal:   'rgba(0,212,170,.12)',
// // //     amber:  'rgba(245,158,11,.12)',
// // //     sky:    'rgba(56,189,248,.1)',
// // //   };

// // //   return (
// // //     <div
// // //       className={`stat-card fade-up fade-up-${delay}`}
// // //       style={{
// // //         background: G.surface,
// // //         border: `1px solid ${G.border}`,
// // //         borderRadius: 14,
// // //         padding: 20,
// // //         position: 'relative',
// // //         overflow: 'hidden',
// // //       }}
// // //     >
// // //       {/* top accent line */}
// // //       <div style={{
// // //         position: 'absolute', top: 0, left: 0, right: 0, height: 2,
// // //         background: topColors[colorClass],
// // //       }} />
// // //       <div style={{
// // //         width: 40, height: 40, borderRadius: 10,
// // //         background: iconBgs[colorClass],
// // //         display: 'flex', alignItems: 'center', justifyContent: 'center',
// // //         fontSize: 18, marginBottom: 14,
// // //       }}>
// // //         {icon}
// // //       </div>
// // //       <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 28, fontWeight: 700, lineHeight: 1 }}>
// // //         {value}
// // //       </div>
// // //       <div style={{ fontSize: 12.5, color: G.textSecondary, marginTop: 6, fontWeight: 500 }}>
// // //         {label}
// // //       </div>
// // //       <div style={{
// // //         fontSize: 11.5, marginTop: 10, display: 'flex', alignItems: 'center', gap: 4,
// // //         color: changeUp ? G.success : G.danger,
// // //       }}>
// // //         {changeUp ? '↑' : '↓'} {change}
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // function QuickSection({ title, badge, items }) {
// // //   return (
// // //     <div style={{
// // //       background: G.surface, border: `1px solid ${G.border}`,
// // //       borderRadius: 14, padding: 20,
// // //     }}>
// // //       <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
// // //         <div style={{ fontSize: 14, fontWeight: 600 }}>{title}</div>
// // //         <div style={{
// // //           fontSize: 11, padding: '3px 8px', borderRadius: 6,
// // //           background: G.surface2, color: G.textSecondary,
// // //         }}>
// // //           {badge}
// // //         </div>
// // //       </div>
// // //       <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
// // //         {items.map(item => (
// // //           <div
// // //             key={item}
// // //             className="ql-pill"
// // //             style={{
// // //               padding: '6px 12px',
// // //               background: G.surface2,
// // //               border: `1px solid ${G.border}`,
// // //               borderRadius: 8,
// // //               fontSize: 12,
// // //               color: G.textSecondary,
// // //               cursor: 'pointer',
// // //               display: 'flex', alignItems: 'center', gap: 6,
// // //             }}
// // //           >
// // //             <span className="ql-dot-inner" style={{
// // //               width: 5, height: 5, borderRadius: '50%',
// // //               background: G.textMuted, flexShrink: 0,
// // //             }} />
// // //             {item}
// // //           </div>
// // //         ))}
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // /* ─── Main Component ─────────────────────────────────────────────────────── */

// // // function AdminPanel() {
// // //   const navigate = useNavigate();
// // //   const [totalCount, setTotalCount] = useState('—');
// // //   const [activeLink, setActiveLink] = useState('');

// // //   /* inject global CSS once */
// // //   useEffect(() => {
// // //     const id = 'admin-panel-styles';
// // //     if (!document.getElementById(id)) {
// // //       const style = document.createElement('style');
// // //       style.id = id;
// // //       style.textContent = globalCss;
// // //       document.head.appendChild(style);
// // //     }
// // //     return () => {
// // //       const el = document.getElementById(id);
// // //       if (el) el.remove();
// // //     };
// // //   }, []);

// // //   /* auth guard */
// // //   useEffect(() => {
// // //     const email    = localStorage.getItem('email');
// // //     const password = localStorage.getItem('password');
// // //     const remember = localStorage.getItem('remember');
// // //     if (remember === 'false' || !email || !password) navigate('/signin');
// // //   }, [navigate]);

// // //   /* fetch total count */
// // //   useEffect(() => {
// // //     const fetchData = async () => {
// // //       try {
// // //         const snapshot = await getDocs(collection(db, 'personal_details'));
// // //         setTotalCount(snapshot.size.toLocaleString('en-IN'));
// // //       } catch (err) {
// // //         console.error('Error fetching data:', err);
// // //       }
// // //     };
// // //     fetchData();
// // //   }, []);

// // //   const logout = () => {
// // //     localStorage.removeItem('email');
// // //     localStorage.removeItem('password');
// // //     localStorage.removeItem('remember');
// // //     navigate('/signin');
// // //   };

// // //   return (
// // //     <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: G.bgDark }}>

// // //       {/* ── SIDEBAR ── */}
// // //       <aside style={{
// // //         width: 260, minWidth: 260,
// // //         background: G.sidebarBg,
// // //         borderRight: `1px solid ${G.sidebarBorder}`,
// // //         display: 'flex', flexDirection: 'column', overflow: 'hidden',
// // //       }}>

// // //         {/* Brand */}
// // //         <div style={{
// // //           padding: '20px 20px 16px',
// // //           display: 'flex', alignItems: 'center', gap: 12,
// // //           borderBottom: `1px solid ${G.border}`, flexShrink: 0,
// // //         }}>
// // //           <div style={{
// // //             width: 36, height: 36,
// // //             background: 'linear-gradient(135deg,#6c63ff,#a78bfa)',
// // //             borderRadius: 10,
// // //             display: 'flex', alignItems: 'center', justifyContent: 'center',
// // //             fontSize: 16, flexShrink: 0,
// // //           }}>
// // //             ⚡
// // //           </div>
// // //           <div>
// // //             <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 15, fontWeight: 700 }}>
// // //               AdminPanel
// // //             </div>
// // //             <div style={{ fontSize: 11, color: G.textSecondary }}>Management Console</div>
// // //           </div>
// // //         </div>

// // //         {/* Nav scroll */}
// // //         <nav style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', padding: '10px 0 16px' }}>
// // //           {NAV_SECTIONS.map(sec => (
// // //             <NavSection
// // //               key={sec.id}
// // //               section={sec}
// // //               activeLink={activeLink}
// // //               setActiveLink={setActiveLink}
// // //             />
// // //           ))}

// // //           {/* Logout */}
// // //           <div style={{ padding: '12px 16px 0' }}>
// // //             <button
// // //               className="logout-btn"
// // //               onClick={logout}
// // //               style={{
// // //                 width: '100%', padding: '10px 16px',
// // //                 display: 'flex', alignItems: 'center', gap: 10,
// // //                 background: 'rgba(239,68,68,.08)',
// // //                 border: '1px solid rgba(239,68,68,.18)',
// // //                 borderRadius: 10,
// // //                 color: G.danger,
// // //                 fontSize: 13, fontWeight: 500,
// // //                 cursor: 'pointer',
// // //               }}
// // //             >
// // //               <span>⎋</span> Logout
// // //             </button>
// // //           </div>
// // //         </nav>

// // //         {/* Footer user row */}
// // //         <div style={{ padding: '14px 16px', borderTop: `1px solid ${G.border}`, flexShrink: 0 }}>
// // //           <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
// // //             <div style={{
// // //               width: 32, height: 32,
// // //               background: 'linear-gradient(135deg,#6c63ff,#00d4aa)',
// // //               borderRadius: 9,
// // //               display: 'flex', alignItems: 'center', justifyContent: 'center',
// // //               fontSize: 13, fontWeight: 700, color: '#fff', flexShrink: 0,
// // //             }}>A</div>
// // //             <div>
// // //               <div style={{ fontSize: 13, fontWeight: 600 }}>Admin</div>
// // //               <div style={{ fontSize: 11, color: G.textMuted }}>Super Admin</div>
// // //             </div>
// // //             <div style={{
// // //               marginLeft: 'auto',
// // //               width: 7, height: 7, borderRadius: '50%',
// // //               background: G.success,
// // //               boxShadow: `0 0 6px ${G.success}`,
// // //             }} />
// // //           </div>
// // //         </div>
// // //       </aside>

// // //       {/* ── MAIN ── */}
// // //       <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

// // //         {/* Topbar */}
// // //         <header style={{
// // //           height: 60,
// // //           background: G.surface,
// // //           borderBottom: `1px solid ${G.border}`,
// // //           display: 'flex', alignItems: 'center',
// // //           padding: '0 28px', gap: 16, flexShrink: 0,
// // //         }}>
// // //           <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 16, fontWeight: 600, flex: 1 }}>
// // //             Dashboard Overview
// // //           </div>
// // //           <div style={{
// // //             background: G.accentGlow, color: G.accent,
// // //             padding: '4px 12px', borderRadius: 20,
// // //             fontSize: 12, fontWeight: 500,
// // //             border: '1px solid rgba(108,99,255,.25)',
// // //           }}>
// // //             ● Live
// // //           </div>
// // //           <div style={{ fontSize: 12, color: G.textSecondary }}>
// // //             {new Date().toLocaleDateString('en-IN', { month: 'short', year: 'numeric' })}
// // //           </div>
// // //           <div style={{
// // //             width: 34, height: 34,
// // //             background: 'linear-gradient(135deg,#6c63ff,#00d4aa)',
// // //             borderRadius: 10,
// // //             display: 'flex', alignItems: 'center', justifyContent: 'center',
// // //             fontSize: 13, fontWeight: 700, color: '#fff', cursor: 'pointer',
// // //           }}>A</div>
// // //         </header>

// // //         {/* Scrollable content */}
// // //         <main style={{ flex: 1, overflowY: 'auto', padding: 28 }}>

// // //           {/* Page heading */}
// // //           <div style={{ marginBottom: 28 }}>
// // //             <h1 style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 24, fontWeight: 700 }}>
// // //               Welcome back, Admin 👋
// // //             </h1>
// // //             <p style={{ color: G.textSecondary, fontSize: 13.5, marginTop: 4 }}>
// // //               Here's what's happening with your platform today.
// // //             </p>
// // //           </div>

// // //           {/* Stat cards */}
// // //           <div style={{
// // //             display: 'grid',
// // //             gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
// // //             gap: 16, marginBottom: 28,
// // //           }}>
// // //             <StatCard icon="📱" value={totalCount}  label="App Downloads"          change="12% from last month" changeUp delay={1} colorClass="purple" />
// // //             <StatCard icon="🎓" value="148"          label="Workshop Registrations"  change="8% this week"       changeUp delay={2} colorClass="teal"   />
// // //             <StatCard icon="📋" value="34"           label="Pending Requests"        change="5 new today"        changeUp delay={3} colorClass="amber"  />
// // //             <StatCard icon="🏆" value="209"          label="Certificates Issued"     change="3% this month"      changeUp delay={4} colorClass="sky"    />
// // //           </div>

// // //           {/* Quick section cards */}
// // //           <div style={{
// // //             display: 'grid', gridTemplateColumns: '1fr 1fr',
// // //             gap: 20, marginBottom: 28,
// // //           }}>
// // //             <QuickSection title="📊 App Data"   badge={`${NAV_SECTIONS[0].items.length} sections`}
// // //               items={NAV_SECTIONS[0].items.slice(0,8).map(i => i.label)} />
// // //             <QuickSection title="📨 Requests"   badge={`${NAV_SECTIONS[1].items.length} sections`}
// // //               items={NAV_SECTIONS[1].items.slice(0,8).map(i => i.label)} />
// // //             <QuickSection title="✏️ Create"     badge={`${NAV_SECTIONS[2].items.length} sections`}
// // //               items={NAV_SECTIONS[2].items.slice(0,8).map(i => i.label)} />
// // //             <QuickSection title="🆕 New / Grow" badge={`${NAV_SECTIONS[3].items.length + NAV_SECTIONS[4].items.length} sections`}
// // //               items={[...NAV_SECTIONS[3].items, ...NAV_SECTIONS[4].items].slice(0,8).map(i => i.label)} />
// // //           </div>

// // //           {/* Recent requests table */}
// // //           <div style={{
// // //             background: G.surface, border: `1px solid ${G.border}`,
// // //             borderRadius: 14, overflow: 'hidden',
// // //           }}>
// // //             <div style={{
// // //               padding: '16px 20px',
// // //               borderBottom: `1px solid ${G.border}`,
// // //               display: 'flex', alignItems: 'center', justifyContent: 'space-between',
// // //             }}>
// // //               <div style={{ fontSize: 14, fontWeight: 600 }}>Recent Requests</div>
// // //               <div style={{ fontSize: 12, color: G.accent, cursor: 'pointer' }}>View all →</div>
// // //             </div>
// // //             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
// // //               <thead>
// // //                 <tr style={{ background: G.surface2, borderBottom: `1px solid ${G.border}` }}>
// // //                   {['User', 'Request Type', 'Date', 'Status'].map(h => (
// // //                     <th key={h} style={{
// // //                       padding: '10px 20px', textAlign: 'left',
// // //                       fontSize: 11, fontWeight: 600, letterSpacing: '.07em',
// // //                       textTransform: 'uppercase', color: G.textMuted,
// // //                     }}>{h}</th>
// // //                   ))}
// // //                 </tr>
// // //               </thead>
// // //               <tbody>
// // //                 {RECENT_REQUESTS.map((row, i) => {
// // //                   const bc = BADGE_COLORS[row.statusClass];
// // //                   return (
// // //                     <tr
// // //                       key={i}
// // //                       className="tbl-row"
// // //                       style={{ borderBottom: i < RECENT_REQUESTS.length - 1 ? `1px solid ${G.border}` : 'none' }}
// // //                     >
// // //                       <td style={{ padding: '12px 20px', fontSize: 13, color: G.textPrimary, fontWeight: 500 }}>{row.user}</td>
// // //                       <td style={{ padding: '12px 20px', fontSize: 13, color: G.textSecondary }}>{row.type}</td>
// // //                       <td style={{ padding: '12px 20px', fontSize: 13, color: G.textSecondary }}>{row.date}</td>
// // //                       <td style={{ padding: '12px 20px' }}>
// // //                         <span style={{
// // //                           display: 'inline-block', padding: '3px 9px', borderRadius: 6,
// // //                           fontSize: 11, fontWeight: 600,
// // //                           background: bc.bg, color: bc.color,
// // //                         }}>{row.status}</span>
// // //                       </td>
// // //                     </tr>
// // //                   );
// // //                 })}
// // //               </tbody>
// // //             </table>
// // //           </div>

// // //           {/* bottom spacer */}
// // //           <div style={{ height: 24 }} />
// // //         </main>
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // export default AdminPanel;


// import React, { useState, useEffect } from 'react';

// import { useNavigate, Link, useParams } from 'react-router-dom';
// import db from "./Firebase";
// import { collection, getDocs, query, limit } from 'firebase/firestore/lite';
// import Moment from 'moment';
// import { extendMoment } from 'moment-range';

// function AdminPanel() {
//     const navigate = useNavigate();
//     const moment = extendMoment(Moment);
//     const [activeIndex, setActiveIndex] = useState(null);
//     const [showAppData, setShowAppData] = useState(false);
//     const [showRequestData, setShowRequestData] = useState(false);
//     const [showCreateData, setShowCreateData] = useState(false);
//     const [showNew, setShowNew] = useState(false);
//     const [showGrow, setShowGrow] = useState(false);
//     const [view, setView] = useState(false);
//     const [activeTabIndex, setActiveTabIndex] = useState(0);
//     const tabData = [
//         { label: 'View App Data', content: 'Content 1' },
//         { label: 'View All Requests', content: 'Content 2' },
//     ];


//     const [totalCount, setTotalCount] = useState(0);

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const snapshot = await getDocs(collection(db, "personal_details"));
//                 const count = snapshot.size; // Get the total count
//                 setTotalCount(count);
//             } catch (error) {
//                 console.error("Error fetching data:", error);
//             }
//         };

//         fetchData();
//     }, []);


//     const logout = () => {
//         localStorage.removeItem("email");
//         localStorage.removeItem("password");
//         localStorage.removeItem("remember");
//         navigate('/signin')
//     };

//     useEffect(() => {
//         const storedUsername = localStorage.getItem("email");
//         const storedPassword = localStorage.getItem("password");
//         const storedRemember = localStorage.getItem("remember");

//         if (storedRemember === "false" || !storedUsername || !storedPassword) {
//             navigate('/signin');
//         }
//     }, []);






//     return (
//         <>
//             <div id="wrapper">


//                 <div id="sidebar-wrapper">
//                     <ul class="sidebar-nav">
//                         <span style={{ cursor: "pointer" }} class=" text-white" > <li class="nav-item mt-3">
//                             <h6 class=" text-uppercase text-xs text-white font-weight-bolder">Home</h6>
//                         </li>
//                         </span>
//                         {/* <Link class={activeIndex === 21 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/" onClick={() => setActiveIndex(21)}>
//                             <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div>
//                             <span class="nav-link-text ms-1">Portfolio Analyser</span>
//                         </Link> */}
//                         {/* <Link class={activeIndex === 22 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/" onClick={() => setActiveIndex(22)}>
//                             <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div>
//                             <span class="nav-link-text ms-1">Portfolio Reviews</span>
//                         </Link> */}
//                         {/* <Link class={activeIndex === 23 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/" onClick={() => setActiveIndex(23)}>
//                             <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div>
//                             <span class="nav-link-text ms-1">All Appointments</span>
//                         </Link> */}
//                         <span style={{ cursor: "pointer" }} class=" text-white" to="/" onClick={() => showAppData ? setShowAppData(false) : setShowAppData(true)}> <li class="nav-item mt-3">
//                             <h6 class=" text-uppercase text-xs text-white font-weight-bolder">View App Data {showAppData ? <><i class="fa fa-arrow-down ml-4" aria-hidden="true"></i></> : <><i class="fa fa-arrow-right ml-4" aria-hidden="true"></i></>}</h6>
//                         </li>
//                         </span>




//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 7 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/users_profile">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Users Profile</span>
//                             </Link>
//                         </li> </> : null}
//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 8 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/portfolio_data">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Portfolio</span>
//                             </Link>
//                         </li> </> : null}

//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 8 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/portfolio_analyser">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Portfolio Analyser</span>
//                             </Link>
//                         </li> </> : null}


//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 8 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/portfolio_reviews">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Portfolio Reviews</span>
//                             </Link>
//                         </li> </> : null}
//                         {/* 
//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 28 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/portfolio_full_data">
                            
//                                 <span class="nav-link-text ms-1">Portfolio All Data</span>
//                             </Link>
//                         </li> </> : null} */}
//                         {/* 
//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 8 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/appointments">
                              
//                                 <span class="nav-link-text ms-1">All Appointments</span>
//                             </Link>
//                         </li> </> : null} */}





//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 9 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/customer_data">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Customer Data</span>
//                             </Link>
//                         </li> </> : null}

//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 10 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/referred_courses">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Referred Courses</span>
//                             </Link>
//                         </li> </> : null}





//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 28 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/location_data">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">User's Location</span>
//                             </Link>
//                         </li> </> : null}



//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 39 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/website_message">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Website Message</span>
//                             </Link>
//                         </li> </> : null}

//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 39 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/app_feedback">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">App Feedback</span>
//                             </Link>
//                         </li> </> : null}

//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 40 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/appointment_analyser">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Appointment Analyser</span>
//                             </Link>
//                         </li> </> : null}

//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 41 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/my_business">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">My Business</span>
//                             </Link>
//                         </li> </> : null}

//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 49 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/clicked_logs">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Clicked Logs</span>
//                             </Link>
//                         </li> </> : null}

//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 79 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/all_certificates">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">All Certificates</span>
//                             </Link>
//                         </li> </> : null}

//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 89 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_feedback">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Workshop Feedback</span>
//                             </Link>
//                         </li> </> : null}

//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 899 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_payment">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Workshops Payment</span>
//                             </Link>
//                         </li> </> : null}

//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 99 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/expenses_list">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Expense List</span>
//                             </Link>
//                         </li> </> : null}

//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 991 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_registration_count">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Registration Count</span>
//                             </Link>
//                         </li> </> : null}
//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 9931 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/app_referral">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">App Referral</span>
//                             </Link>
//                         </li> </> : null}

//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 9932 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/feedback_reply">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Feedback Reply</span>
//                             </Link>
//                         </li> </> : null}

//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 9932 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/user_last_checkin">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Users Checkin</span>
//                             </Link>
//                         </li> </> : null}

//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 9932 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/login_logs">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Login Logs</span>
//                             </Link>
//                         </li> </> : null}

//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 9932 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/downloaded_certificate">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Downloaded Cert.</span>
//                             </Link>
//                         </li> </> : null}


//                         {showAppData ? <><li class="nav-item">
//                             <Link class={activeIndex === 9939 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/topic_request">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Topic Request</span>
//                             </Link>
//                         </li> </> : null}





//                         <span style={{ cursor: "pointer" }} class=" text-white" to="/" onClick={() => showRequestData ? setShowRequestData(false) : setShowRequestData(true)}>   <li class="nav-item mt-3">
//                             <h6 class=" text-uppercase text-xs text-white font-weight-bolder">View All request {showRequestData ? <><i class="fa fa-arrow-down ml-4" aria-hidden="true"></i></> : <><i class="fa fa-arrow-right ml-4" aria-hidden="true"></i></>}</h6>
//                         </li> </span>
//                         {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 11 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/beauty_kit_requests">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">table_view</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Beauty Kit Requests</span>
//                             </Link>
//                         </li> </> : null}

//                         {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 1199 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/upcoming_session">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">table_view</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Upcoming Session</span>
//                             </Link>
//                         </li> </> : null}


//                         {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 12 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/book_demo_requests">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">receipt_long</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Book Demo Requests</span>
//                             </Link>
//                         </li> </> : null}
//                         {/* {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 13 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/business_card_request" >
//                                 <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">view_in_ar</i>
//                                 </div>
//                                 <span class="nav-link-text ms-1">Business card Requests</span>
//                             </Link>
//                         </li> </> : null} */}
//                         {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 14 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/hire_request">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Hire Requests</span>
//                             </Link>
//                         </li> </> : null}
//                         {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 14 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/event_request">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Event Requests</span>
//                             </Link>
//                         </li> </> : null}
//                         {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 15 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/loan_request">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">notifications</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Loan Requests</span>
//                             </Link>
//                         </li> </> : null}
//                         {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 15 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/loan_remark">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">notifications</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Loan Remarks</span>
//                             </Link>
//                         </li> </> : null}
//                         {/* {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 16 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/premium_card_request">
                              
//                                 <span class="nav-link-text ms-1">Premium Card Req.</span>
//                             </Link>
//                         </li> </> : null} */}

//                         {/* {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 16 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/premium_smg_request">
                             
//                                 <span class="nav-link-text ms-1">Premium SMG Req.</span>
//                             </Link>
//                         </li> </> : null} */}


//                         {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 17 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_registration">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Workshop Registration</span>
//                             </Link>
//                         </li> </> : null}
//                         {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 17 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_payment">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Workshop Payment</span>
//                             </Link>
//                         </li> </> : null}

//                         {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 18 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">All Workshop</span>
//                             </Link>
//                         </li> </> : null}

//                         {showRequestData ? <><li class="nav-item">
//                             <Link class={activeIndex === 59 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_query">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Workshop Query</span>
//                             </Link>
//                         </li> </> : null}

//                         {showRequestData ? <><li class="nav-item">
//                             <Link class={activeIndex === 59 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_event_request">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Workshop Event Request</span>
//                             </Link>
//                         </li> </> : null}



//                         {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 20 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/delete_portfolio_req">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Delete Portfolio Req.</span>
//                             </Link>
//                         </li> </> : null}

//                         {/* {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 116 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/banner_request">
                            
//                                 <span class="nav-link-text ms-1">Banner Request</span>
//                             </Link>
//                         </li> </> : null} */}

//                         {/* {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 116 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/premium_banner_request">
                                
//                                 <span class="nav-link-text ms-1">Premium Banner Request</span>
//                             </Link>
//                         </li> </> : null} */}

//                         {/* {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 117 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/smg_request">
                             
//                                 <span class="nav-link-text ms-1">SMG Request</span>
//                             </Link>
//                         </li> </> : null} */}

//                         {/* {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 118 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/whatsapp_business_request">
                           
//                                 <span class="nav-link-text ms-1">WB Request</span>
//                             </Link>
//                         </li> </> : null} */}
//                         {/* 
//                         {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 119 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/google_business_request">
                              
//                                 <span class="nav-link-text ms-1">GB Request</span>
//                             </Link>
//                         </li> </> : null} */}


//                         {showRequestData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 120 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/advertise_feedback">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Advertise Feedback</span>
//                             </Link>
//                         </li> </> : null}





//                         <span style={{ cursor: "pointer" }} class=" text-white" to="/" onClick={() => showCreateData ? setShowCreateData(false) : setShowCreateData(true)}>   <li class="nav-item mt-3">
//                             <h6 class=" text-uppercase text-xs text-white font-weight-bolder">Create {showCreateData ? <><i class="fa fa-arrow-down ml-4" aria-hidden="true"></i></> : <><i class="fa fa-arrow-right ml-4" aria-hidden="true"></i></>}</h6>
//                         </li> </span>

//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 5 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/guidance_session">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">notifications</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Guidance Session</span>
//                             </Link>
//                         </li> </> : null}

//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 5 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_data">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">notifications</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Workshop</span>
//                             </Link>
//                         </li> </> : null}

//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 6 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_data_hindi">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Workshop Hindi</span>
//                             </Link>
//                         </li> </> : null}

//                         {showCreateData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 48 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_reminder">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Workshop Reminder</span>
//                             </Link>
//                         </li> </> : null}

//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 60 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/pin_workshop">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Pin Workshop</span>
//                             </Link>
//                         </li> </> : null}

//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 61 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_attendance">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Workshop Attendance</span>
//                             </Link>
//                         </li> </> : null}


//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 689 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_glimpses">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Workshop Glimpses</span>
//                             </Link>
//                         </li> </> : null}

//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 62 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_attendance_status">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Attendance Status </span>
//                             </Link>
//                         </li> </> : null}


//                         {showCreateData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 22 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/upload_recorded_video">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Upload Recorded Session</span>
//                             </Link>
//                         </li> </> : null}


//                         {showCreateData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 58 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/upload_certificates">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Upload Certificate</span>
//                             </Link>
//                         </li> </> : null}




//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 10 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/send_whatsapp">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Send Whatsapp</span>
//                             </Link>
//                         </li> </> : null}

//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 10 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/create_whatsapp_template">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Create Whatsapp Template</span>
//                             </Link>
//                         </li> </> : null}

//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 0 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/course_data" >
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">dashboard</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Courses</span>
//                             </Link>
//                         </li> </> : null}
//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 1 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/course_data_hindi">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">table_view</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Course Hindi</span>
//                             </Link>
//                         </li> </> : null}

//                         {/* {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 2 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/promotional_data">
                             
//                                 <span class="nav-link-text ms-1">Create an Offer (premade)</span>
//                             </Link>
//                         </li> </> : null}

//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 1225 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/custom_cards">
                           
//                                 <span class="nav-link-text ms-1">Create an Offer (custom) </span>
//                             </Link>
//                         </li> </> : null} */}
//                         {/* {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 3 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/freebusinesscards_data">
                            
//                                 <span class="nav-link-text ms-1">Add Free Vist. Cards</span>
//                             </Link>
//                         </li> </> : null} */}
//                         {/* {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 4 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/premiumcards_data">
                             
//                                 <span class="nav-link-text ms-1">Premium Cards</span>
//                             </Link>
//                         </li> </> : null} */}

//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 38 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/add_slider_images">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Add Slider Images</span>
//                             </Link>
//                         </li> </> : null}

//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 78 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_slider_image">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Add Workshop Slider</span>
//                             </Link>
//                         </li> </> : null}

//                         {/* {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 111 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/banner_design">
                              
//                                 <span class="nav-link-text ms-1">Add Free Banner Design</span>
//                             </Link>
//                         </li> </> : null} */}

//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 112 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/global_notification">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Add Global Notification</span>
//                             </Link>
//                         </li> </> : null}

//                         {/* {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 113 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/previous_card_work">
                              
//                                 <span class="nav-link-text ms-1">Add Prem. Vist Cards</span>
//                             </Link>
//                         </li> </> : null} */}



//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 115 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/advertise_download">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Advertise Download</span>
//                             </Link>
//                         </li> </> : null}

//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 115 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/session_slider_images">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">After Session Slider</span>
//                             </Link>
//                         </li> </> : null}


//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 1225 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_code">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Workshop Code</span>
//                             </Link>
//                         </li> </> : null}


//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 1225 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_tag">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Workshop Tag</span>
//                             </Link>
//                         </li> </> : null}

//                         {/* {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 1225 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/social_media_graphics">
                             
//                                 <span class="nav-link-text ms-1">Add Free SMG</span>
//                             </Link>
//                         </li> </> : null} */}

//                         {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 1225 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/advertise_slider">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Add Adv Slider</span>
//                             </Link>
//                         </li> </> : null}

//                         {/* {showCreateData ? <><li class="nav-item">
//                             <Link class={activeIndex === 1225 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/previous_sm">
                         
//                                 <span class="nav-link-text ms-1">Add Prem SMG </span>
//                             </Link>
//                         </li> </> : null} */}





//                         <span style={{ cursor: "pointer" }} class=" text-white" to="/" onClick={() => showNew ? setShowNew(false) : setShowNew(true)}>   <li class="nav-item mt-3">
//                             <h6 class=" text-uppercase text-xs text-white font-weight-bolder">New {showNew ? <><i class="fa fa-arrow-down ml-4" aria-hidden="true"></i></> : <><i class="fa fa-arrow-right ml-4" aria-hidden="true"></i></>}</h6>
//                         </li> </span>


//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 5 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/CourseUploadForm">

//                                 <span class="nav-link-text ms-1">Upload Course</span>
//                             </Link>
//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/add_quiz">

//                                 <span class="nav-link-text ms-1">Add Quiz</span>
//                             </Link>
//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/add_expert">

//                                 <span class="nav-link-text ms-1">Add Expert</span>
//                             </Link>
//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/custom_enrollment">

//                                 <span class="nav-link-text ms-1">Add Enrollment</span>
//                             </Link>
//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/course_enrollment">

//                                 <span class="nav-link-text ms-1">View Course Enrollment</span>
//                             </Link>
//                         </li> </> : null}


//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/membership_tracking">

//                                 <span class="nav-link-text ms-1">Membership Data</span>
//                             </Link>
//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/bookings">

//                                 <span class="nav-link-text ms-1">Booking</span>
//                             </Link>
//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/add_doubt_session">

//                                 <span class="nav-link-text ms-1">Add Doubt Sessions</span>
//                             </Link>
//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/doubt_session">

//                                 <span class="nav-link-text ms-1">Doubt Sessions data</span>
//                             </Link>
//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/community">

//                                 <span class="nav-link-text ms-1">Community</span>
//                             </Link>
//                         </li> </> : null}

//                         {/* {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/call_back_request">

//                                 <span class="nav-link-text ms-1">Call back request</span>
//                             </Link>
//                         </li> </> : null} */}



//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/query_data">

//                                 <span class="nav-link-text ms-1">App Queries</span>
//                             </Link>
//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/faqs_query">

//                                 <span class="nav-link-text ms-1">Faqs Query</span>
//                             </Link>
//                         </li> </> : null}

//                         {/* {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/studio_review">

//                                 <span class="nav-link-text ms-1">Studio Reviews</span>
//                             </Link>
//                         </li> </> : null} */}



//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/profile_type">

//                                 <span class="nav-link-text ms-1">Profile Type</span>
//                             </Link>
//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/course_video_update">

//                                 <span class="nav-link-text ms-1">Course Video Update</span>
//                             </Link>
//                         </li> </> : null}


//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/course_attendance_update">

//                                 <span class="nav-link-text ms-1">Course Attendance Update</span>
//                             </Link>
//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/course_timestamp_update">

//                                 <span class="nav-link-text ms-1">Course Timestamp Update</span>
//                             </Link>
//                         </li> </> : null}


//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 8 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/appointment_booked">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Booked Appointments</span>
//                             </Link>
//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 40 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/appointment_analyser">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Appointment Analyser</span>
//                             </Link>
//                         </li> </> : null}


//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 40 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/finance_query">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Finance Query</span>
//                             </Link>
//                         </li> </> : null}



//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 40 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/certificate_downloads">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Certificate Download</span>
//                             </Link>
//                         </li> </> : null}


//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 40 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/users_course_data">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Course Report</span>
//                             </Link>
//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 40 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/analytics_preview">
//                                 <span class="nav-link-text ms-1">Analytics Preview</span>
//                             </Link>
//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 40 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/dashbaordall">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Log Analytics</span>
//                             </Link>
//                         </li> </> : null}
//                         {/* {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 40 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/add_growcard">
                               
//                                 <span class="nav-link-text ms-1">Add DIY</span>
//                             </Link>
//                         </li> </> : null} */}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 40 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/apptopbanner">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Homepage Banner</span>
//                             </Link>
//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 61 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/homepage_poster">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Homepage Poster</span>
//                             </Link>
//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 62 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/transaction_history">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Transaction History</span>
//                             </Link>
//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 63 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/requested_topics">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Requested Topics</span>
//                             </Link>
//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/know_more_about_course">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Know More About Course</span>
//                             </Link>

//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/active_membership">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Active Members</span>
//                             </Link>

//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/downloaded_certificate_data">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Certificate Data</span>
//                             </Link>

//                         </li> </> : null}


//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshop_registrations">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Workshop Registration</span>
//                             </Link>

//                         </li> </> : null}


//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/UdyamRegistrationData">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Udyam Registration</span>
//                             </Link>

//                         </li> </> : null}


//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/EcommerceSupportData">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Ecommerce Support Data</span>
//                             </Link>

//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/editcoursepage">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Edit Course</span>
//                             </Link>

//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/workshophindiversion">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Hindi Workshop Name</span>
//                             </Link>

//                         </li> </> : null}

//                         {showNew ? <><li class="nav-item">
//                             <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/invoice_data">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Invoices</span>
//                             </Link>

//                         </li> </> : null}















//                         <span style={{ cursor: "pointer" }} class=" text-white" to="/" onClick={() => showGrow ? setShowGrow(false) : setShowGrow(true)}>   <li class="nav-item mt-3">
//                             <h6 class=" text-uppercase text-xs text-white font-weight-bolder">Grow {showGrow ? <><i class="fa fa-arrow-down ml-4" aria-hidden="true"></i></> : <><i class="fa fa-arrow-right ml-4" aria-hidden="true"></i></>}</h6>
//                         </li> </span>

//                         {showGrow ? <> <li class="nav-item">
//                             <Link class={activeIndex === 19 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/call_back_request">
//                                 {/* <Link class={activeIndex === 19 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/request_callback">call_back_request */}
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">Call Back Request</span>
//                             </Link>
//                         </li> </> : null}


//                         {showGrow ? <><li class="nav-item">
//                             <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/grow_all_data">

//                                 <span class="nav-link-text ms-1">Grow Data</span>
//                             </Link>
//                         </li> </> : null}

//                         {showGrow ? <><li class="nav-item">
//                             <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/readymadepage">

//                                 <span class="nav-link-text ms-1">Ready Made Delete</span>
//                             </Link>

//                         </li> </> : null}


//                         {showGrow ? <><li class="nav-item">
//                             <Link class={activeIndex === 64 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/diycardpage">
//                                 {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                     <i class="material-icons opacity-10">format_textdirection_r_to_l</i>
//                                 </div> */}
//                                 <span class="nav-link-text ms-1">DIY Delete</span>
//                             </Link>

//                         </li> </> : null}



//                         {showGrow ? <><li class="nav-item">
//                             <Link class={activeIndex === 52 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/orders_data">

//                                 <span class="nav-link-text ms-1">Studio Requests</span>
//                             </Link>
//                         </li> </> : null}



//                         {/* {showCreateData ? <> <li class="nav-item">
//                             <Link class={activeIndex === 60 ? "nav-link text-white active bg-gradient-primary" : "nav-link text-white"} to="/push_notifications">
                              
//                                 <span class="nav-link-text ms-1">Push Notification</span>
//                             </Link>
//                         </li> </> : null} */}

//                         <span style={{ cursor: "pointer" }} class=" text-white" onClick={() => logout()}> <li class="nav-item mt-3">
//                             <h6 class=" text-uppercase text-xs text-white font-weight-bolder">Logout <i class="fa fa-sign-out ml-4" aria-hidden="true" style={{ "fontSize": "20px", "color": "white" }}></i></h6>
//                         </li>
//                         </span>

//                         <li class="nav-item">
//                             <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                 <i class="material-icons opacity-10"></i>
//                             </div>
//                             <span class="nav-link-text ms-1"></span>
//                         </li>
//                         <li class="nav-item">
//                             {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                 <i class="material-icons opacity-10"></i>
//                             </div> */}
//                             <span class="nav-link-text ms-1"></span>
//                         </li>
//                         <li class="nav-item">
//                             {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                 <i class="material-icons opacity-10"></i>
//                             </div> */}
//                             <span class="nav-link-text ms-1"></span>
//                         </li>
//                         <li class="nav-item">
//                             {/* <div class="text-white text-center me-2 d-flex align-items-center justify-content-center">
//                                 <i class="material-icons opacity-10"></i>
//                             </div> */}
//                             <span class="nav-link-text ms-1"></span>
//                         </li>




//                     </ul>
//                 </div>

//                 <div id="page-content-wrapper" style={{ overflowY: "auto", background: "#f4f6fb", minHeight: "100vh", padding: "28px 28px 28px 58px" }}>

//                     {/* Welcome Header */}
//                     <div style={{
//                         background: "linear-gradient(135deg, #1e3a5f 0%, #2563eb 60%, #6c63ff 100%)",
//                         borderRadius: "18px", padding: "28px 32px", marginBottom: "24px",
//                         position: "relative", overflow: "hidden",
//                     }}>
//                         <div style={{ position: "absolute", top: -30, right: -30, width: 160, height: 160, borderRadius: "50%", background: "rgba(255,255,255,0.06)" }} />
//                         <div style={{ position: "absolute", bottom: -50, right: 80, width: 200, height: 200, borderRadius: "50%", background: "rgba(255,255,255,0.04)" }} />
//                         <div style={{ position: "relative", zIndex: 1 }}>
//                             <div style={{ fontSize: "10px", fontWeight: 700, color: "rgba(255,255,255,0.55)", letterSpacing: "0.18em", textTransform: "uppercase", marginBottom: "8px" }}>
//                                 Admin Console
//                             </div>
//                             <h3 style={{ color: "#fff", fontWeight: 800, margin: 0, fontSize: "24px" }}>Welcome back, Admin 👋</h3>
//                             <p style={{ color: "rgba(255,255,255,0.65)", fontSize: "13px", marginTop: "5px", marginBottom: 0 }}>
//                                 {new Date().toLocaleDateString("en-IN", { weekday: "long", day: "2-digit", month: "long", year: "numeric" })}
//                             </p>
//                         </div>
//                     </div>

//                     {/* Stat Card */}
//                     <div style={{ marginBottom: "24px" }}>
//                         <div style={{ background: "#fff", borderRadius: "14px", padding: "20px", boxShadow: "0 2px 12px rgba(0,0,0,.07)", display: "inline-block", minWidth: "180px" }}>
//                             <div style={{ width: 40, height: 40, borderRadius: 11, background: "linear-gradient(135deg,#6c63ff,#a78bfa)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 19, marginBottom: 14 }}>📱</div>
//                             <div style={{ fontSize: 26, fontWeight: 900, color: "#111827", lineHeight: 1 }}>{totalCount}</div>
//                             <div style={{ fontSize: 11.5, color: "#6b7280", marginTop: 6, fontWeight: 500 }}>App Downloads</div>
//                         </div>
//                     </div>

//                     {/* Quick Access Section */}
//                     <div>

//                         {/* Quick Jump Bar */}
//                         <div style={{
//                             background: "#fff", borderRadius: "14px", padding: "16px 20px",
//                             boxShadow: "0 4px 16px rgba(0,0,0,.07)",
//                             display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap",
//                             marginBottom: "20px",
//                         }}>
//                             <span style={{ fontSize: "12px", fontWeight: 700, color: "#9ca3af", letterSpacing: "0.1em", textTransform: "uppercase", marginRight: "4px" }}>
//                                 ⚡ Quick Jump
//                             </span>
//                             {[
//                                 { label: "Shiksha Members", to: "/shiksha_membership_users", color: "#6c63ff" },
//                                 { label: "Glow Active Users", to: "/glow_active_users",       color: "#0284c7" },
//                                 { label: "Loan Data",         to: "/loan_data",               color: "#d97706" },
//                                 { label: "ABC Users",         to: "/abc_users_data",          color: "#16a34a" },
//                                 { label: "Workshop Attend.", to: "/workshop_data_datewise",   color: "#7c3aed" },
//                                 { label: "Invoice Data",     to: "/invoice_data",             color: "#db2777" },
//                             ].map(q => (
//                                 <Link key={q.to} to={q.to} style={{
//                                     fontSize: "12px", padding: "5px 14px", borderRadius: "20px",
//                                     background: `${q.color}12`,
//                                     color: q.color, textDecoration: "none",
//                                     border: `1px solid ${q.color}30`, fontWeight: 600,
//                                 }}>
//                                     {q.label}
//                                 </Link>
//                             ))}
//                         </div>

//                         <div style={{ fontSize: "13px", fontWeight: 700, color: "#374151", marginBottom: "14px", letterSpacing: "0.05em", textTransform: "uppercase" }}>
//                             Quick Access
//                         </div>

//                         <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: "16px", marginBottom: "24px" }}>
//                             {[
//                                 {
//                                     title: "View App Data", emoji: "📊", grad: "linear-gradient(135deg,#0284c7,#38bdf8)", color: "#0284c7",
//                                     links: [
//                                         { label: "Users Profile", to: "/users_profile" },
//                                         { label: "Customer Data", to: "/customer_data" },
//                                         { label: "Login Logs", to: "/login_logs" },
//                                         { label: "Workshop Feedback", to: "/workshop_feedback" },
//                                         { label: "App Feedback", to: "/app_feedback" },
//                                         { label: "Expense List", to: "/expenses_list" },
//                                     ],
//                                 },
//                                 {
//                                     title: "View All Requests", emoji: "📨", grad: "linear-gradient(135deg,#d97706,#fbbf24)", color: "#d97706",
//                                     links: [
//                                         { label: "Beauty Kit Requests", to: "/beauty_kit_requests" },
//                                         { label: "Book Demo Requests", to: "/book_demo_requests" },
//                                         { label: "Loan Requests", to: "/loan_request" },
//                                         { label: "Workshop Registration", to: "/workshop_registration" },
//                                         { label: "Hire Requests", to: "/hire_request" },
//                                         { label: "Workshop Query", to: "/workshop_query" },
//                                     ],
//                                 },
//                                 {
//                                     title: "Create", emoji: "✏️", grad: "linear-gradient(135deg,#16a34a,#4ade80)", color: "#16a34a",
//                                     links: [
//                                         { label: "Workshop", to: "/workshop_data" },
//                                         { label: "Guidance Session", to: "/guidance_session" },
//                                         { label: "Send Whatsapp", to: "/send_whatsapp" },
//                                         { label: "Courses", to: "/course_data" },
//                                         { label: "Workshop Attendance", to: "/workshop_attendance" },
//                                         { label: "Global Notification", to: "/global_notification" },
//                                     ],
//                                 },
//                                 {
//                                     title: "New & Grow", emoji: "🆕", grad: "linear-gradient(135deg,#7c3aed,#a78bfa)", color: "#7c3aed",
//                                     links: [
//                                         { label: "Membership Data", to: "/membership_tracking" },
//                                         { label: "Transaction History", to: "/transaction_history" },
//                                         { label: "Course Enrollment", to: "/course_enrollment" },
//                                         { label: "Active Members", to: "/active_membership" },
//                                         { label: "Analytics Preview", to: "/analytics_preview" },
//                                         { label: "Grow Data", to: "/grow_all_data" },
//                                     ],
//                                 },
//                             ].map(section => (
//                                 <div key={section.title} style={{
//                                     background: "#fff", borderRadius: "16px",
//                                     boxShadow: "0 4px 16px rgba(0,0,0,.07)", overflow: "hidden",
//                                 }}>
//                                     {/* Card header */}
//                                     <div style={{
//                                         background: section.grad,
//                                         padding: "14px 18px",
//                                         display: "flex", alignItems: "center", gap: "10px",
//                                     }}>
//                                         <span style={{
//                                             width: 32, height: 32, borderRadius: 9,
//                                             background: "rgba(255,255,255,0.25)",
//                                             display: "flex", alignItems: "center", justifyContent: "center",
//                                             fontSize: 16,
//                                         }}>{section.emoji}</span>
//                                         <span style={{ color: "#fff", fontWeight: 700, fontSize: "14px" }}>{section.title}</span>
//                                     </div>
//                                     {/* Links */}
//                                     <div style={{ padding: "12px 14px", display: "flex", flexDirection: "column", gap: "4px" }}>
//                                         {section.links.map(link => (
//                                             <Link
//                                                 key={link.to}
//                                                 to={link.to}
//                                                 style={{
//                                                     fontSize: "12.5px", color: "#374151", textDecoration: "none",
//                                                     padding: "7px 10px", borderRadius: "8px",
//                                                     display: "flex", alignItems: "center", gap: "8px",
//                                                 }}
//                                                 onMouseEnter={e => { e.currentTarget.style.background = `${section.color}12`; e.currentTarget.style.color = section.color; }}
//                                                 onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#374151"; }}
//                                             >
//                                                 <span style={{ width: 4, height: 4, borderRadius: "50%", background: section.color, flexShrink: 0, display: "inline-block" }} />
//                                                 {link.label}
//                                             </Link>
//                                         ))}
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>

//                     </div>

//                 </div>


//             </div>
//         </>
//     )
// }

// export default AdminPanel;
